export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AboutIntroBlocksDynamicZoneInput: { input: any; output: any };
  AboutOutroBlocksDynamicZoneInput: { input: any; output: any };
  ContactBlocksDynamicZoneInput: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  HomepageHomepageBlocksDynamicZoneInput: { input: any; output: any };
  JSON: { input: any; output: any };
  LandingPageLandingPageBlocksDynamicZoneInput: { input: any; output: any };
  MenuMenuItemsDynamicZoneInput: { input: any; output: any };
  PageBlocksDynamicZoneInput: { input: any; output: any };
  ResourceArticleBlocksDynamicZoneInput: { input: any; output: any };
  ResourceCategoryBlocksDynamicZoneInput: { input: any; output: any };
  ResourceCenterBlocksAboveCategoriesDynamicZoneInput: { input: any; output: any };
  ResourceCenterBlocksBelowCategoriesDynamicZoneInput: { input: any; output: any };
};

export type About = {
  __typename?: 'About';
  HeroImage?: Maybe<UploadFile>;
  HeroText?: Maybe<Scalars['JSON']['output']>;
  IntroBlocks?: Maybe<Array<Maybe<AboutIntroBlocksDynamicZone>>>;
  LocationBody?: Maybe<Scalars['JSON']['output']>;
  LocationHeading?: Maybe<Scalars['JSON']['output']>;
  LocationImage?: Maybe<UploadFile>;
  OutroBlocks?: Maybe<Array<Maybe<AboutOutroBlocksDynamicZone>>>;
  PrimaryTeamMembers: Array<Maybe<TeamMember>>;
  PrimaryTeamMembers_connection?: Maybe<TeamMemberRelationResponseCollection>;
  TeamContent?: Maybe<Scalars['JSON']['output']>;
  Teams?: Maybe<Array<Maybe<ComponentBlocksTeam>>>;
  Timeline?: Maybe<Array<Maybe<ComponentBlocksTimeline>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AboutPrimaryTeamMembersArgs = {
  filters?: InputMaybe<TeamMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AboutPrimaryTeamMembers_ConnectionArgs = {
  filters?: InputMaybe<TeamMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AboutTeamsArgs = {
  filters?: InputMaybe<ComponentBlocksTeamFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AboutTimelineArgs = {
  filters?: InputMaybe<ComponentBlocksTimelineFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AboutInput = {
  HeroImage?: InputMaybe<Scalars['ID']['input']>;
  HeroText?: InputMaybe<Scalars['JSON']['input']>;
  IntroBlocks?: InputMaybe<Array<Scalars['AboutIntroBlocksDynamicZoneInput']['input']>>;
  LocationBody?: InputMaybe<Scalars['JSON']['input']>;
  LocationHeading?: InputMaybe<Scalars['JSON']['input']>;
  LocationImage?: InputMaybe<Scalars['ID']['input']>;
  OutroBlocks?: InputMaybe<Array<Scalars['AboutOutroBlocksDynamicZoneInput']['input']>>;
  PrimaryTeamMembers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  TeamContent?: InputMaybe<Scalars['JSON']['input']>;
  Teams?: InputMaybe<Array<InputMaybe<ComponentBlocksTeamInput>>>;
  Timeline?: InputMaybe<Array<InputMaybe<ComponentBlocksTimelineInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
};

export type AboutIntroBlocksDynamicZone =
  | ComponentBlocksActionBlock
  | ComponentBlocksAdditionalFeatures
  | ComponentBlocksAuthorDetails
  | ComponentBlocksBreak
  | ComponentBlocksCalculatorGrid
  | ComponentBlocksCta
  | ComponentBlocksFaqList
  | ComponentBlocksFunnel
  | ComponentBlocksHighlightBlock
  | ComponentBlocksHtml
  | ComponentBlocksImage
  | ComponentBlocksInfoTilesBlock
  | ComponentBlocksLatestResourcesBlock
  | ComponentBlocksLenderList
  | ComponentBlocksLoanCalculators
  | ComponentBlocksMetricHighlight
  | ComponentBlocksPageSeparator
  | ComponentBlocksPlatformReviewsBlock
  | ComponentBlocksPostcard
  | ComponentBlocksProductFeatures
  | ComponentBlocksProsAndConsTable
  | ComponentBlocksProsAndConsTableV2
  | ComponentBlocksRelatedArticles
  | ComponentBlocksRelatedBlogs
  | ComponentBlocksStepsList
  | ComponentBlocksTableWidget
  | ComponentBlocksText
  | ComponentBlocksThreeColumnText
  | ComponentBlocksThreeSteps
  | ComponentBlocksTwoColumnTextImageBlock
  | ComponentCalculatorCalculatorHighlight
  | ComponentLoanLoanComparison
  | ComponentLoanLoanHighlight
  | Error;

export type AboutOutroBlocksDynamicZone =
  | ComponentBlocksActionBlock
  | ComponentBlocksAdditionalFeatures
  | ComponentBlocksAuthorDetails
  | ComponentBlocksBreak
  | ComponentBlocksCalculatorGrid
  | ComponentBlocksCta
  | ComponentBlocksFaqList
  | ComponentBlocksFunnel
  | ComponentBlocksHighlightBlock
  | ComponentBlocksHtml
  | ComponentBlocksImage
  | ComponentBlocksInfoTilesBlock
  | ComponentBlocksLatestResourcesBlock
  | ComponentBlocksLenderList
  | ComponentBlocksLoanCalculators
  | ComponentBlocksMetricHighlight
  | ComponentBlocksPageSeparator
  | ComponentBlocksPlatformReviewsBlock
  | ComponentBlocksPostcard
  | ComponentBlocksProductFeatures
  | ComponentBlocksProsAndConsTable
  | ComponentBlocksProsAndConsTableV2
  | ComponentBlocksRelatedArticles
  | ComponentBlocksRelatedBlogs
  | ComponentBlocksStepsList
  | ComponentBlocksTableWidget
  | ComponentBlocksText
  | ComponentBlocksThreeColumnText
  | ComponentBlocksThreeSteps
  | ComponentBlocksTwoColumnTextImageBlock
  | ComponentCalculatorCalculatorHighlight
  | ComponentLoanLoanComparison
  | ComponentLoanLoanHighlight
  | Error;

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CalculatorCategory = {
  __typename?: 'CalculatorCategory';
  CategoryIcon?: Maybe<UploadFile>;
  calculators: Array<Maybe<FinancialCalculator>>;
  calculators_connection?: Maybe<FinancialCalculatorRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  loan_calculators: Array<Maybe<LoanCalculator>>;
  loan_calculators_connection?: Maybe<LoanCalculatorRelationResponseCollection>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CalculatorCategoryCalculatorsArgs = {
  filters?: InputMaybe<FinancialCalculatorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CalculatorCategoryCalculators_ConnectionArgs = {
  filters?: InputMaybe<FinancialCalculatorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CalculatorCategoryLoan_CalculatorsArgs = {
  filters?: InputMaybe<LoanCalculatorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CalculatorCategoryLoan_Calculators_ConnectionArgs = {
  filters?: InputMaybe<LoanCalculatorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CalculatorCategoryEntityResponseCollection = {
  __typename?: 'CalculatorCategoryEntityResponseCollection';
  nodes: Array<CalculatorCategory>;
  pageInfo: Pagination;
};

export type CalculatorCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CalculatorCategoryFiltersInput>>>;
  calculators?: InputMaybe<FinancialCalculatorFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  loan_calculators?: InputMaybe<LoanCalculatorFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CalculatorCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CalculatorCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CalculatorCategoryInput = {
  CategoryIcon?: InputMaybe<Scalars['ID']['input']>;
  calculators?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  loan_calculators?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentBlocksActionBlock = {
  __typename?: 'ComponentBlocksActionBlock';
  ActionBlockBackground?: Maybe<ComponentSharedBackground>;
  ActionBlockDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  AsideContent?: Maybe<Scalars['JSON']['output']>;
  AsidePosition?: Maybe<Enum_Componentblocksactionblock_Asideposition>;
  ButtonArrow?: Maybe<Scalars['Boolean']['output']>;
  ButtonLink?: Maybe<Scalars['String']['output']>;
  ButtonText?: Maybe<Scalars['String']['output']>;
  CTAFooter?: Maybe<Scalars['String']['output']>;
  CTAIntro?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksAdditionalFeatures = {
  __typename?: 'ComponentBlocksAdditionalFeatures';
  AdditionalFeature?: Maybe<Array<Maybe<ComponentBlocksFeature>>>;
  AdditionalFeaturesBackground?: Maybe<ComponentSharedBackground>;
  AdditionalFeaturesDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksAdditionalFeaturesAdditionalFeatureArgs = {
  filters?: InputMaybe<ComponentBlocksFeatureFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksAuthorDetails = {
  __typename?: 'ComponentBlocksAuthorDetails';
  AuthorDetailsBackground?: Maybe<ComponentSharedBackground>;
  AuthorDetailsDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  AuthorSectionDetails?: Maybe<Scalars['JSON']['output']>;
  AuthorSectionStat?: Maybe<Scalars['String']['output']>;
  ReviewedBy?: Maybe<TeamMember>;
  ReviewedByOverride?: Maybe<Scalars['JSON']['output']>;
  ShowBio?: Maybe<Scalars['Boolean']['output']>;
  ShowReviewedByLabel?: Maybe<Scalars['Boolean']['output']>;
  ShowSocialLabels?: Maybe<Scalars['Boolean']['output']>;
  ShowWrittenByLabel?: Maybe<Scalars['Boolean']['output']>;
  WrittenBy?: Maybe<TeamMember>;
  WrittenByOverride?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksAuthorDetailsFiltersInput = {
  AuthorDetailsBackground?: InputMaybe<ComponentSharedBackgroundFiltersInput>;
  AuthorDetailsDisplayOptions?: InputMaybe<ComponentSharedDisplayOptionsFiltersInput>;
  AuthorSectionDetails?: InputMaybe<JsonFilterInput>;
  AuthorSectionStat?: InputMaybe<StringFilterInput>;
  ReviewedBy?: InputMaybe<TeamMemberFiltersInput>;
  ReviewedByOverride?: InputMaybe<JsonFilterInput>;
  ShowBio?: InputMaybe<BooleanFilterInput>;
  ShowReviewedByLabel?: InputMaybe<BooleanFilterInput>;
  ShowSocialLabels?: InputMaybe<BooleanFilterInput>;
  ShowWrittenByLabel?: InputMaybe<BooleanFilterInput>;
  WrittenBy?: InputMaybe<TeamMemberFiltersInput>;
  WrittenByOverride?: InputMaybe<JsonFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksAuthorDetailsFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksAuthorDetailsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksAuthorDetailsFiltersInput>>>;
};

export type ComponentBlocksAuthorDetailsInput = {
  AuthorDetailsBackground?: InputMaybe<ComponentSharedBackgroundInput>;
  AuthorDetailsDisplayOptions?: InputMaybe<ComponentSharedDisplayOptionsInput>;
  AuthorSectionDetails?: InputMaybe<Scalars['JSON']['input']>;
  AuthorSectionStat?: InputMaybe<Scalars['String']['input']>;
  ReviewedBy?: InputMaybe<Scalars['ID']['input']>;
  ReviewedByOverride?: InputMaybe<Scalars['JSON']['input']>;
  ShowBio?: InputMaybe<Scalars['Boolean']['input']>;
  ShowReviewedByLabel?: InputMaybe<Scalars['Boolean']['input']>;
  ShowSocialLabels?: InputMaybe<Scalars['Boolean']['input']>;
  ShowWrittenByLabel?: InputMaybe<Scalars['Boolean']['input']>;
  WrittenBy?: InputMaybe<Scalars['ID']['input']>;
  WrittenByOverride?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBlocksBottomPageMetric = {
  __typename?: 'ComponentBlocksBottomPageMetric';
  MetricInfo?: Maybe<Array<Maybe<ComponentBlocksMetricHighlightInfo>>>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksBottomPageMetricMetricInfoArgs = {
  filters?: InputMaybe<ComponentBlocksMetricHighlightInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksBreak = {
  __typename?: 'ComponentBlocksBreak';
  BreakBackground?: Maybe<ComponentSharedBackground>;
  BreakDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  Height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentBlocksButton = {
  __typename?: 'ComponentBlocksButton';
  ButtonLink?: Maybe<Scalars['String']['output']>;
  ButtonNumberValue?: Maybe<Scalars['Boolean']['output']>;
  ButtonPlaceholder?: Maybe<Scalars['String']['output']>;
  ButtonText?: Maybe<Scalars['String']['output']>;
  ShowButton?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksButtonFiltersInput = {
  ButtonLink?: InputMaybe<StringFilterInput>;
  ButtonNumberValue?: InputMaybe<BooleanFilterInput>;
  ButtonPlaceholder?: InputMaybe<StringFilterInput>;
  ButtonText?: InputMaybe<StringFilterInput>;
  ShowButton?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksButtonFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksButtonFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksButtonFiltersInput>>>;
};

export type ComponentBlocksButtonInput = {
  ButtonLink?: InputMaybe<Scalars['String']['input']>;
  ButtonNumberValue?: InputMaybe<Scalars['Boolean']['input']>;
  ButtonPlaceholder?: InputMaybe<Scalars['String']['input']>;
  ButtonText?: InputMaybe<Scalars['String']['input']>;
  ShowButton?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBlocksCalculatorGrid = {
  __typename?: 'ComponentBlocksCalculatorGrid';
  CalculatorGridBackground?: Maybe<ComponentSharedBackground>;
  CalculatorGridDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  CalculatorTitle?: Maybe<Scalars['String']['output']>;
  Calculators: Array<Maybe<FinancialCalculator>>;
  Calculators_connection?: Maybe<FinancialCalculatorRelationResponseCollection>;
  Column?: Maybe<Scalars['Int']['output']>;
  Rows?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksCalculatorGridCalculatorsArgs = {
  filters?: InputMaybe<FinancialCalculatorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksCalculatorGridCalculators_ConnectionArgs = {
  filters?: InputMaybe<FinancialCalculatorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksConList = {
  __typename?: 'ComponentBlocksConList';
  ConItem?: Maybe<Scalars['String']['output']>;
  ConLogo?: Maybe<UploadFile>;
  Description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksConTableList = {
  __typename?: 'ComponentBlocksConTableList';
  ConItemDescription?: Maybe<Scalars['JSON']['output']>;
  ConItemLogo?: Maybe<UploadFile>;
  ConItemTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksConTableListFiltersInput = {
  ConItemDescription?: InputMaybe<JsonFilterInput>;
  ConItemTitle?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksConTableListFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksConTableListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksConTableListFiltersInput>>>;
};

export type ComponentBlocksCta = {
  __typename?: 'ComponentBlocksCta';
  Body?: Maybe<Scalars['JSON']['output']>;
  CTAAlignment?: Maybe<Enum_Componentblockscta_Ctaalignment>;
  CTAButtonStyle?: Maybe<Enum_Componentblockscta_Ctabuttonstyle>;
  CTAHeroMediaDisplay?: Maybe<Enum_Componentblockscta_Ctaheromediadisplay>;
  CtaBackground?: Maybe<ComponentSharedBackground>;
  CtaDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  CtaHeroMedia?: Maybe<UploadFile>;
  CtaText: Scalars['String']['output'];
  CtaUrl: Scalars['String']['output'];
  FootNote?: Maybe<Scalars['String']['output']>;
  HideInnerBackground?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksFaqList = {
  __typename?: 'ComponentBlocksFaqList';
  Body?: Maybe<Scalars['JSON']['output']>;
  Columns: Scalars['Int']['output'];
  FaqListBackground?: Maybe<ComponentSharedBackground>;
  FaqListDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  FaqListImage?: Maybe<UploadFile>;
  FaqListStyle?: Maybe<Enum_Componentblocksfaqlist_Faqliststyle>;
  Offset: Scalars['Int']['output'];
  Questions?: Maybe<Array<Maybe<ComponentBlocksQuestionList>>>;
  Variant: Enum_Componentblocksfaqlist_Variant;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksFaqListQuestionsArgs = {
  filters?: InputMaybe<ComponentBlocksQuestionListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksFeature = {
  __typename?: 'ComponentBlocksFeature';
  Desc?: Maybe<Scalars['JSON']['output']>;
  Header?: Maybe<Scalars['String']['output']>;
  Logo?: Maybe<UploadFile>;
  SubHeader?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksFeatureFiltersInput = {
  Desc?: InputMaybe<JsonFilterInput>;
  Header?: InputMaybe<StringFilterInput>;
  SubHeader?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksFeatureFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksFeatureFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksFeatureFiltersInput>>>;
};

export type ComponentBlocksFunnel = {
  __typename?: 'ComponentBlocksFunnel';
  FunnelBackground?: Maybe<ComponentSharedBackground>;
  FunnelButtonLabel?: Maybe<Scalars['String']['output']>;
  FunnelContents?: Maybe<Scalars['JSON']['output']>;
  FunnelDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  FunnelFootNote?: Maybe<Scalars['String']['output']>;
  FunnelHeader?: Maybe<Scalars['String']['output']>;
  FunnelHideInnerBackground?: Maybe<Scalars['Boolean']['output']>;
  FunnelLogo?: Maybe<UploadFile>;
  FunnelPopupTimer?: Maybe<Scalars['Int']['output']>;
  FunnelSubHeader?: Maybe<Scalars['String']['output']>;
  FunnelVariant?: Maybe<Enum_Componentblocksfunnel_Funnelvariant>;
  InputLabel?: Maybe<Scalars['String']['output']>;
  InputLink?: Maybe<Scalars['String']['output']>;
  InputPlaceholder?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksFunnelFiltersInput = {
  FunnelBackground?: InputMaybe<ComponentSharedBackgroundFiltersInput>;
  FunnelButtonLabel?: InputMaybe<StringFilterInput>;
  FunnelContents?: InputMaybe<JsonFilterInput>;
  FunnelDisplayOptions?: InputMaybe<ComponentSharedDisplayOptionsFiltersInput>;
  FunnelFootNote?: InputMaybe<StringFilterInput>;
  FunnelHeader?: InputMaybe<StringFilterInput>;
  FunnelHideInnerBackground?: InputMaybe<BooleanFilterInput>;
  FunnelPopupTimer?: InputMaybe<IntFilterInput>;
  FunnelSubHeader?: InputMaybe<StringFilterInput>;
  FunnelVariant?: InputMaybe<StringFilterInput>;
  InputLabel?: InputMaybe<StringFilterInput>;
  InputLink?: InputMaybe<StringFilterInput>;
  InputPlaceholder?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksFunnelFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksFunnelFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksFunnelFiltersInput>>>;
};

export type ComponentBlocksFunnelInput = {
  FunnelBackground?: InputMaybe<ComponentSharedBackgroundInput>;
  FunnelButtonLabel?: InputMaybe<Scalars['String']['input']>;
  FunnelContents?: InputMaybe<Scalars['JSON']['input']>;
  FunnelDisplayOptions?: InputMaybe<ComponentSharedDisplayOptionsInput>;
  FunnelFootNote?: InputMaybe<Scalars['String']['input']>;
  FunnelHeader?: InputMaybe<Scalars['String']['input']>;
  FunnelHideInnerBackground?: InputMaybe<Scalars['Boolean']['input']>;
  FunnelLogo?: InputMaybe<Scalars['ID']['input']>;
  FunnelPopupTimer?: InputMaybe<Scalars['Int']['input']>;
  FunnelSubHeader?: InputMaybe<Scalars['String']['input']>;
  FunnelVariant?: InputMaybe<Enum_Componentblocksfunnel_Funnelvariant>;
  InputLabel?: InputMaybe<Scalars['String']['input']>;
  InputLink?: InputMaybe<Scalars['String']['input']>;
  InputPlaceholder?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBlocksHeroForm = {
  __typename?: 'ComponentBlocksHeroForm';
  HeroBackground?: Maybe<ComponentSharedBackground>;
  HeroBackgroundImage?: Maybe<UploadFile>;
  HeroCTA?: Maybe<Array<Maybe<ComponentBlocksButton>>>;
  HeroDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  HeroMedia?: Maybe<UploadFile>;
  HeroMediaDisplay?: Maybe<Enum_Componentblocksheroform_Heromediadisplay>;
  HeroText: Scalars['JSON']['output'];
  ShowReview?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksHeroFormHeroCtaArgs = {
  filters?: InputMaybe<ComponentBlocksButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksHeroFormFiltersInput = {
  HeroBackground?: InputMaybe<ComponentSharedBackgroundFiltersInput>;
  HeroCTA?: InputMaybe<ComponentBlocksButtonFiltersInput>;
  HeroDisplayOptions?: InputMaybe<ComponentSharedDisplayOptionsFiltersInput>;
  HeroMediaDisplay?: InputMaybe<StringFilterInput>;
  HeroText?: InputMaybe<JsonFilterInput>;
  ShowReview?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksHeroFormFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksHeroFormFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksHeroFormFiltersInput>>>;
};

export type ComponentBlocksHeroFormInput = {
  HeroBackground?: InputMaybe<ComponentSharedBackgroundInput>;
  HeroBackgroundImage?: InputMaybe<Scalars['ID']['input']>;
  HeroCTA?: InputMaybe<Array<InputMaybe<ComponentBlocksButtonInput>>>;
  HeroDisplayOptions?: InputMaybe<ComponentSharedDisplayOptionsInput>;
  HeroMedia?: InputMaybe<Scalars['ID']['input']>;
  HeroMediaDisplay?: InputMaybe<Enum_Componentblocksheroform_Heromediadisplay>;
  HeroText?: InputMaybe<Scalars['JSON']['input']>;
  ShowReview?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBlocksHeroSimple = {
  __typename?: 'ComponentBlocksHeroSimple';
  SimpleHeroBackground?: Maybe<ComponentSharedBackground>;
  SimpleHeroBullets?: Maybe<Scalars['String']['output']>;
  SimpleHeroDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  SimpleHeroText: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentBlocksHeroSimpleFiltersInput = {
  SimpleHeroBackground?: InputMaybe<ComponentSharedBackgroundFiltersInput>;
  SimpleHeroBullets?: InputMaybe<StringFilterInput>;
  SimpleHeroDisplayOptions?: InputMaybe<ComponentSharedDisplayOptionsFiltersInput>;
  SimpleHeroText?: InputMaybe<JsonFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksHeroSimpleFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksHeroSimpleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksHeroSimpleFiltersInput>>>;
};

export type ComponentBlocksHeroSimpleInput = {
  SimpleHeroBackground?: InputMaybe<ComponentSharedBackgroundInput>;
  SimpleHeroBullets?: InputMaybe<Scalars['String']['input']>;
  SimpleHeroDisplayOptions?: InputMaybe<ComponentSharedDisplayOptionsInput>;
  SimpleHeroText?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBlocksHighlightBlock = {
  __typename?: 'ComponentBlocksHighlightBlock';
  AlignImageRight?: Maybe<Scalars['Boolean']['output']>;
  BackgroundImage?: Maybe<UploadFile>;
  HighlightBackground?: Maybe<ComponentSharedBackground>;
  HighlightDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  HighlightVariant?: Maybe<Enum_Componentblockshighlightblock_Highlightvariant>;
  QuoteAuthor?: Maybe<Scalars['String']['output']>;
  Text?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksHomepageHeroForm = {
  __typename?: 'ComponentBlocksHomepageHeroForm';
  HeroBackground?: Maybe<ComponentSharedBackground>;
  HeroBackgroundImage?: Maybe<UploadFile>;
  HeroBody?: Maybe<Scalars['JSON']['output']>;
  HeroCTA?: Maybe<Array<Maybe<ComponentBlocksButton>>>;
  HeroCreditNote?: Maybe<Scalars['String']['output']>;
  HeroDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  HeroLenderCount?: Maybe<Scalars['String']['output']>;
  HeroLenderLabel?: Maybe<Scalars['String']['output']>;
  HeroMatchLabel?: Maybe<Scalars['String']['output']>;
  HeroMatchSuffix?: Maybe<Scalars['String']['output']>;
  HeroMedia?: Maybe<UploadFile>;
  HeroMediaDisplay?: Maybe<Enum_Componentblockshomepageheroform_Heromediadisplay>;
  HeroText?: Maybe<Scalars['JSON']['output']>;
  HeroTitleAccent?: Maybe<Scalars['String']['output']>;
  HeroTitleMain?: Maybe<Scalars['String']['output']>;
  ShowReview?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksHomepageHeroFormHeroCtaArgs = {
  filters?: InputMaybe<ComponentBlocksButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksHomepageHeroFormInput = {
  HeroBackground?: InputMaybe<ComponentSharedBackgroundInput>;
  HeroBackgroundImage?: InputMaybe<Scalars['ID']['input']>;
  HeroBody?: InputMaybe<Scalars['JSON']['input']>;
  HeroCTA?: InputMaybe<Array<InputMaybe<ComponentBlocksButtonInput>>>;
  HeroCreditNote?: InputMaybe<Scalars['String']['input']>;
  HeroDisplayOptions?: InputMaybe<ComponentSharedDisplayOptionsInput>;
  HeroLenderCount?: InputMaybe<Scalars['String']['input']>;
  HeroLenderLabel?: InputMaybe<Scalars['String']['input']>;
  HeroMatchLabel?: InputMaybe<Scalars['String']['input']>;
  HeroMatchSuffix?: InputMaybe<Scalars['String']['input']>;
  HeroMedia?: InputMaybe<Scalars['ID']['input']>;
  HeroMediaDisplay?: InputMaybe<Enum_Componentblockshomepageheroform_Heromediadisplay>;
  HeroText?: InputMaybe<Scalars['JSON']['input']>;
  HeroTitleAccent?: InputMaybe<Scalars['String']['input']>;
  HeroTitleMain?: InputMaybe<Scalars['String']['input']>;
  ShowReview?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBlocksHtml = {
  __typename?: 'ComponentBlocksHtml';
  HtmlContent: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentBlocksImage = {
  __typename?: 'ComponentBlocksImage';
  CustomHeight?: Maybe<Scalars['Int']['output']>;
  CustomWidth?: Maybe<Scalars['Int']['output']>;
  ImageBackground?: Maybe<ComponentSharedBackground>;
  ImageCaption?: Maybe<Scalars['String']['output']>;
  ImageDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  Images: Array<Maybe<UploadFile>>;
  Images_connection?: Maybe<UploadFileRelationResponseCollection>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksImageImagesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksImageImages_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksInfoTile = {
  __typename?: 'ComponentBlocksInfoTile';
  TileContents?: Maybe<Scalars['JSON']['output']>;
  TileMedia?: Maybe<UploadFile>;
  TileSize?: Maybe<Enum_Componentblocksinfotile_Tilesize>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksInfoTileFiltersInput = {
  TileContents?: InputMaybe<JsonFilterInput>;
  TileSize?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksInfoTileFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksInfoTileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksInfoTileFiltersInput>>>;
};

export type ComponentBlocksInfoTilesBlock = {
  __typename?: 'ComponentBlocksInfoTilesBlock';
  InfoTilesBackground?: Maybe<ComponentSharedBackground>;
  InfoTilesDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  InfoTilesIntro?: Maybe<Scalars['JSON']['output']>;
  TileRows?: Maybe<Array<Maybe<ComponentBlocksInfoTilesRow>>>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksInfoTilesBlockTileRowsArgs = {
  filters?: InputMaybe<ComponentBlocksInfoTilesRowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksInfoTilesRow = {
  __typename?: 'ComponentBlocksInfoTilesRow';
  RowColumns?: Maybe<Enum_Componentblocksinfotilesrow_Rowcolumns>;
  Tiles?: Maybe<Array<Maybe<ComponentBlocksInfoTile>>>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksInfoTilesRowTilesArgs = {
  filters?: InputMaybe<ComponentBlocksInfoTileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksInfoTilesRowFiltersInput = {
  RowColumns?: InputMaybe<StringFilterInput>;
  Tiles?: InputMaybe<ComponentBlocksInfoTileFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksInfoTilesRowFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksInfoTilesRowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksInfoTilesRowFiltersInput>>>;
};

export type ComponentBlocksLandingPageHero = {
  __typename?: 'ComponentBlocksLandingPageHero';
  LandingHeroBackground?: Maybe<ComponentSharedBackground>;
  LandingHeroBlurb?: Maybe<Scalars['JSON']['output']>;
  LandingHeroBullets?: Maybe<Scalars['String']['output']>;
  LandingHeroCTA?: Maybe<Array<Maybe<ComponentBlocksButton>>>;
  LandingHeroDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  LandingHeroMarqueeBullets?: Maybe<Scalars['Boolean']['output']>;
  LandingHeroMedia?: Maybe<UploadFile>;
  LandingHeroMediaDisplay?: Maybe<Enum_Componentblockslandingpagehero_Landingheromediadisplay>;
  LandingHeroMobileMedia: Array<Maybe<UploadFile>>;
  LandingHeroMobileMedia_connection?: Maybe<UploadFileRelationResponseCollection>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksLandingPageHeroLandingHeroCtaArgs = {
  filters?: InputMaybe<ComponentBlocksButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksLandingPageHeroLandingHeroMobileMediaArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksLandingPageHeroLandingHeroMobileMedia_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksLandingPageHeroFiltersInput = {
  LandingHeroBackground?: InputMaybe<ComponentSharedBackgroundFiltersInput>;
  LandingHeroBlurb?: InputMaybe<JsonFilterInput>;
  LandingHeroBullets?: InputMaybe<StringFilterInput>;
  LandingHeroCTA?: InputMaybe<ComponentBlocksButtonFiltersInput>;
  LandingHeroDisplayOptions?: InputMaybe<ComponentSharedDisplayOptionsFiltersInput>;
  LandingHeroMarqueeBullets?: InputMaybe<BooleanFilterInput>;
  LandingHeroMediaDisplay?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksLandingPageHeroFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksLandingPageHeroFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksLandingPageHeroFiltersInput>>>;
};

export type ComponentBlocksLandingPageHeroInput = {
  LandingHeroBackground?: InputMaybe<ComponentSharedBackgroundInput>;
  LandingHeroBlurb?: InputMaybe<Scalars['JSON']['input']>;
  LandingHeroBullets?: InputMaybe<Scalars['String']['input']>;
  LandingHeroCTA?: InputMaybe<Array<InputMaybe<ComponentBlocksButtonInput>>>;
  LandingHeroDisplayOptions?: InputMaybe<ComponentSharedDisplayOptionsInput>;
  LandingHeroMarqueeBullets?: InputMaybe<Scalars['Boolean']['input']>;
  LandingHeroMedia?: InputMaybe<Scalars['ID']['input']>;
  LandingHeroMediaDisplay?: InputMaybe<Enum_Componentblockslandingpagehero_Landingheromediadisplay>;
  LandingHeroMobileMedia?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBlocksLatestResourcesBlock = {
  __typename?: 'ComponentBlocksLatestResourcesBlock';
  LatestResourcesBackground?: Maybe<ComponentSharedBackground>;
  LatestResourcesDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  MaxResources: Scalars['Int']['output'];
  ResourceCategories: Array<Maybe<ResourceCategory>>;
  ResourceCategories_connection?: Maybe<ResourceCategoryRelationResponseCollection>;
  Title?: Maybe<Scalars['String']['output']>;
  ViewMoreLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentBlocksLatestResourcesBlockResourceCategoriesArgs = {
  filters?: InputMaybe<ResourceCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksLatestResourcesBlockResourceCategories_ConnectionArgs = {
  filters?: InputMaybe<ResourceCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksLenderList = {
  __typename?: 'ComponentBlocksLenderList';
  LenderListBackground?: Maybe<ComponentSharedBackground>;
  LenderListBorderLogos?: Maybe<Scalars['Boolean']['output']>;
  LenderListDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  LenderLogos: Array<Maybe<UploadFile>>;
  LenderLogos_connection?: Maybe<UploadFileRelationResponseCollection>;
  NumberOfLenders?: Maybe<Scalars['String']['output']>;
  TitleText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksLenderListLenderLogosArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksLenderListLenderLogos_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksLoanCalculators = {
  __typename?: 'ComponentBlocksLoanCalculators';
  CalculatorBackground?: Maybe<ComponentSharedBackground>;
  CalculatorBlurb?: Maybe<Scalars['JSON']['output']>;
  CalculatorDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  CalculatorType: Enum_Componentblocksloancalculators_Calculatortype;
  CustomCalculatorTitle?: Maybe<Scalars['String']['output']>;
  CustomInputsTitle?: Maybe<Scalars['String']['output']>;
  CustomOutputsTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksLogosBlock = {
  __typename?: 'ComponentBlocksLogosBlock';
  Logos: Array<Maybe<UploadFile>>;
  LogosBlockBackground?: Maybe<ComponentSharedBackground>;
  LogosBlockDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  Logos_connection: UploadFileRelationResponseCollection;
  Title: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentBlocksLogosBlockLogosArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksLogosBlockLogos_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksMetricHighlight = {
  __typename?: 'ComponentBlocksMetricHighlight';
  MetricHighlightBackground?: Maybe<ComponentSharedBackground>;
  MetricHighlightDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  MetricHighlightInfo?: Maybe<Array<Maybe<ComponentBlocksMetricHighlightInfo>>>;
  MetricHighlightTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksMetricHighlightMetricHighlightInfoArgs = {
  filters?: InputMaybe<ComponentBlocksMetricHighlightInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksMetricHighlightFiltersInput = {
  MetricHighlightBackground?: InputMaybe<ComponentSharedBackgroundFiltersInput>;
  MetricHighlightDisplayOptions?: InputMaybe<ComponentSharedDisplayOptionsFiltersInput>;
  MetricHighlightInfo?: InputMaybe<ComponentBlocksMetricHighlightInfoFiltersInput>;
  MetricHighlightTitle?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksMetricHighlightFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksMetricHighlightFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksMetricHighlightFiltersInput>>>;
};

export type ComponentBlocksMetricHighlightInfo = {
  __typename?: 'ComponentBlocksMetricHighlightInfo';
  MetricDescription?: Maybe<Scalars['String']['output']>;
  MetricInfo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksMetricHighlightInfoFiltersInput = {
  MetricDescription?: InputMaybe<StringFilterInput>;
  MetricInfo?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksMetricHighlightInfoFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksMetricHighlightInfoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksMetricHighlightInfoFiltersInput>>>;
};

export type ComponentBlocksMetricHighlightInfoInput = {
  MetricDescription?: InputMaybe<Scalars['String']['input']>;
  MetricInfo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBlocksMetricHighlightInput = {
  MetricHighlightBackground?: InputMaybe<ComponentSharedBackgroundInput>;
  MetricHighlightDisplayOptions?: InputMaybe<ComponentSharedDisplayOptionsInput>;
  MetricHighlightInfo?: InputMaybe<Array<InputMaybe<ComponentBlocksMetricHighlightInfoInput>>>;
  MetricHighlightTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBlocksPageSeparator = {
  __typename?: 'ComponentBlocksPageSeparator';
  PageSeparatorBackground?: Maybe<ComponentSharedBackground>;
  PageSeparatorDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  ReviewedBy?: Maybe<TeamMember>;
  SeparatorBlurb?: Maybe<Scalars['JSON']['output']>;
  SeparatorDescription?: Maybe<Scalars['String']['output']>;
  SeparatorTitle?: Maybe<Scalars['String']['output']>;
  UpdatedDate?: Maybe<Scalars['Date']['output']>;
  WrittenBy?: Maybe<TeamMember>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksPlatformReviewsBlock = {
  __typename?: 'ComponentBlocksPlatformReviewsBlock';
  ReviewType: Enum_Componentblocksplatformreviewsblock_Reviewtype;
  ReviewsBackground?: Maybe<Array<Maybe<ComponentSharedBackground>>>;
  ReviewsDisplayOptions?: Maybe<Array<Maybe<ComponentSharedDisplayOptions>>>;
  ReviewsIntro?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksPlatformReviewsBlockReviewsBackgroundArgs = {
  filters?: InputMaybe<ComponentSharedBackgroundFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksPlatformReviewsBlockReviewsDisplayOptionsArgs = {
  filters?: InputMaybe<ComponentSharedDisplayOptionsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksPostcard = {
  __typename?: 'ComponentBlocksPostcard';
  Background: UploadFile;
  PostcardBlockBackground?: Maybe<ComponentSharedBackground>;
  PostcardDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  Tagline?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentBlocksProList = {
  __typename?: 'ComponentBlocksProList';
  Description?: Maybe<Scalars['String']['output']>;
  ProItem?: Maybe<Scalars['String']['output']>;
  ProLogo?: Maybe<UploadFile>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksProTableList = {
  __typename?: 'ComponentBlocksProTableList';
  ProItemDescription?: Maybe<Scalars['JSON']['output']>;
  ProItemLogo?: Maybe<UploadFile>;
  ProItemTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksProTableListFiltersInput = {
  ProItemDescription?: InputMaybe<JsonFilterInput>;
  ProItemTitle?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksProTableListFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksProTableListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksProTableListFiltersInput>>>;
};

export type ComponentBlocksProductFeatures = {
  __typename?: 'ComponentBlocksProductFeatures';
  ComponentBackgroundColour?: Maybe<Enum_Componentblocksproductfeatures_Componentbackgroundcolour>;
  HeaderText?: Maybe<Scalars['JSON']['output']>;
  ProductFeaturesBackground?: Maybe<ComponentSharedBackground>;
  ProductFeaturesDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  ProductFeaturesImageAlignment?: Maybe<Enum_Componentblocksproductfeatures_Productfeaturesimagealignment>;
  ProductFeaturesImageBorder?: Maybe<Scalars['Boolean']['output']>;
  ProductFeaturesImageColumnSize?: Maybe<Enum_Componentblocksproductfeatures_Productfeaturesimagecolumnsize>;
  ProductFeaturesItemSpacing?: Maybe<Enum_Componentblocksproductfeatures_Productfeaturesitemspacing>;
  ProductFeaturesRoundImageCorners?: Maybe<Scalars['Boolean']['output']>;
  ProductFeaturesTextColumnSize?: Maybe<Enum_Componentblocksproductfeatures_Productfeaturestextcolumnsize>;
  Tabs?: Maybe<Array<Maybe<ComponentBlocksProductFeaturesTabs>>>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksProductFeaturesTabsArgs = {
  filters?: InputMaybe<ComponentBlocksProductFeaturesTabsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksProductFeaturesTabs = {
  __typename?: 'ComponentBlocksProductFeaturesTabs';
  Body: Scalars['JSON']['output'];
  ButtonLink?: Maybe<Scalars['String']['output']>;
  ButtonText?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<UploadFile>;
  ImageColRight?: Maybe<Scalars['Boolean']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksProductFeaturesTabsFiltersInput = {
  Body?: InputMaybe<JsonFilterInput>;
  ButtonLink?: InputMaybe<StringFilterInput>;
  ButtonText?: InputMaybe<StringFilterInput>;
  ImageColRight?: InputMaybe<BooleanFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksProductFeaturesTabsFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksProductFeaturesTabsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksProductFeaturesTabsFiltersInput>>>;
};

export type ComponentBlocksProsAndConsTable = {
  __typename?: 'ComponentBlocksProsAndConsTable';
  ConList?: Maybe<Array<Maybe<ComponentBlocksConTableList>>>;
  LeftColText: Scalars['String']['output'];
  ProList?: Maybe<Array<Maybe<ComponentBlocksProTableList>>>;
  ProsAndConsBackground?: Maybe<ComponentSharedBackground>;
  ProsAndConsDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  RightColText: Scalars['String']['output'];
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksProsAndConsTableConListArgs = {
  filters?: InputMaybe<ComponentBlocksConTableListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksProsAndConsTableProListArgs = {
  filters?: InputMaybe<ComponentBlocksProTableListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksProsAndConsTableV2 = {
  __typename?: 'ComponentBlocksProsAndConsTableV2';
  ProsAndConsBackground?: Maybe<ComponentSharedBackground>;
  ProsAndConsDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  ProsAndConsTitle?: Maybe<Scalars['String']['output']>;
  TableRows?: Maybe<Array<Maybe<ComponentRepeatableProsAndConsRow>>>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksProsAndConsTableV2TableRowsArgs = {
  filters?: InputMaybe<ComponentRepeatableProsAndConsRowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksQuestionList = {
  __typename?: 'ComponentBlocksQuestionList';
  Answer: Scalars['JSON']['output'];
  Group?: Maybe<Scalars['String']['output']>;
  Question: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentBlocksQuestionListFiltersInput = {
  Answer?: InputMaybe<JsonFilterInput>;
  Group?: InputMaybe<StringFilterInput>;
  Question?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksQuestionListFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksQuestionListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksQuestionListFiltersInput>>>;
};

export type ComponentBlocksRelatedArticles = {
  __typename?: 'ComponentBlocksRelatedArticles';
  Pages: Array<Maybe<Page>>;
  Pages_connection?: Maybe<PageRelationResponseCollection>;
  RelatedArticlesBackground?: Maybe<ComponentSharedBackground>;
  RelatedArticlesDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  ShowLatestByDefault?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksRelatedArticlesPagesArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksRelatedArticlesPages_ConnectionArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksRelatedBlogs = {
  __typename?: 'ComponentBlocksRelatedBlogs';
  Blogs: Array<Maybe<ResourceArticle>>;
  Blogs_connection?: Maybe<ResourceArticleRelationResponseCollection>;
  HighlightBlog?: Maybe<ResourceArticle>;
  RelatedBlogsBackground?: Maybe<ComponentSharedBackground>;
  RelatedBlogsDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  ShowLatestByDefault?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksRelatedBlogsBlogsArgs = {
  filters?: InputMaybe<ResourceArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksRelatedBlogsBlogs_ConnectionArgs = {
  filters?: InputMaybe<ResourceArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksStepItem = {
  __typename?: 'ComponentBlocksStepItem';
  Description?: Maybe<Scalars['JSON']['output']>;
  Image?: Maybe<UploadFile>;
  StepItemCta?: Maybe<ComponentBlocksButton>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksStepItemFiltersInput = {
  Description?: InputMaybe<JsonFilterInput>;
  StepItemCta?: InputMaybe<ComponentBlocksButtonFiltersInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksStepItemFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksStepItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksStepItemFiltersInput>>>;
};

export type ComponentBlocksStepsList = {
  __typename?: 'ComponentBlocksStepsList';
  Steps?: Maybe<Array<Maybe<ComponentBlocksStepItem>>>;
  StepsListBackground?: Maybe<ComponentSharedBackground>;
  StepsListBlurb?: Maybe<Scalars['JSON']['output']>;
  StepsListDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  StepsListShowNumbers?: Maybe<Scalars['Boolean']['output']>;
  StepsListStyle?: Maybe<Enum_Componentblocksstepslist_Stepsliststyle>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksStepsListStepsArgs = {
  filters?: InputMaybe<ComponentBlocksStepItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksTable = {
  __typename?: 'ComponentBlocksTable';
  Headings?: Maybe<Scalars['JSON']['output']>;
  TableContent: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentBlocksTableCellItem = {
  __typename?: 'ComponentBlocksTableCellItem';
  Align?: Maybe<Enum_Componentblockstablecellitem_Align>;
  Content?: Maybe<Scalars['JSON']['output']>;
  FontSize?: Maybe<Enum_Componentblockstablecellitem_Fontsize>;
  VerticalAlign?: Maybe<Enum_Componentblockstablecellitem_Verticalalign>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksTableCellItemFiltersInput = {
  Align?: InputMaybe<StringFilterInput>;
  Content?: InputMaybe<JsonFilterInput>;
  FontSize?: InputMaybe<StringFilterInput>;
  VerticalAlign?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksTableCellItemFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksTableCellItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksTableCellItemFiltersInput>>>;
};

export type ComponentBlocksTableHeadingItem = {
  __typename?: 'ComponentBlocksTableHeadingItem';
  Align?: Maybe<Enum_Componentblockstableheadingitem_Align>;
  FontSize?: Maybe<Enum_Componentblockstableheadingitem_Fontsize>;
  Label?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksTableHeadingItemFiltersInput = {
  Align?: InputMaybe<StringFilterInput>;
  FontSize?: InputMaybe<StringFilterInput>;
  Label?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksTableHeadingItemFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksTableHeadingItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksTableHeadingItemFiltersInput>>>;
};

export type ComponentBlocksTableRowItem = {
  __typename?: 'ComponentBlocksTableRowItem';
  Cells?: Maybe<Array<Maybe<ComponentBlocksTableCellItem>>>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksTableRowItemCellsArgs = {
  filters?: InputMaybe<ComponentBlocksTableCellItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksTableRowItemFiltersInput = {
  Cells?: InputMaybe<ComponentBlocksTableCellItemFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksTableRowItemFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksTableRowItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksTableRowItemFiltersInput>>>;
};

export type ComponentBlocksTableWidget = {
  __typename?: 'ComponentBlocksTableWidget';
  ColumnWidthPreset?: Maybe<Enum_Componentblockstablewidget_Columnwidthpreset>;
  DisableTableRowHover?: Maybe<Scalars['Boolean']['output']>;
  DisableTableRowStripe?: Maybe<Scalars['Boolean']['output']>;
  TableBackground?: Maybe<ComponentSharedBackground>;
  TableDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  TableHeadings?: Maybe<Array<Maybe<ComponentBlocksTableHeadingItem>>>;
  TableInnerBackgroundColor?: Maybe<Enum_Componentblockstablewidget_Tableinnerbackgroundcolor>;
  TableRows?: Maybe<Array<Maybe<ComponentBlocksTableRowItem>>>;
  TableSubContent?: Maybe<Scalars['JSON']['output']>;
  TableTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksTableWidgetTableHeadingsArgs = {
  filters?: InputMaybe<ComponentBlocksTableHeadingItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksTableWidgetTableRowsArgs = {
  filters?: InputMaybe<ComponentBlocksTableRowItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksTeam = {
  __typename?: 'ComponentBlocksTeam';
  Name: Scalars['String']['output'];
  TeamMembers: Array<Maybe<TeamMember>>;
  TeamMembers_connection?: Maybe<TeamMemberRelationResponseCollection>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksTeamTeamMembersArgs = {
  filters?: InputMaybe<TeamMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksTeamTeamMembers_ConnectionArgs = {
  filters?: InputMaybe<TeamMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksTeamFiltersInput = {
  Name?: InputMaybe<StringFilterInput>;
  TeamMembers?: InputMaybe<TeamMemberFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksTeamFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksTeamFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksTeamFiltersInput>>>;
};

export type ComponentBlocksTeamInput = {
  Name?: InputMaybe<Scalars['String']['input']>;
  TeamMembers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBlocksText = {
  __typename?: 'ComponentBlocksText';
  Body?: Maybe<Scalars['JSON']['output']>;
  Columns: Scalars['Int']['output'];
  Offset: Scalars['Int']['output'];
  TextBlockBackground?: Maybe<ComponentSharedBackground>;
  TextBlockDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksThreeColumnText = {
  __typename?: 'ComponentBlocksThreeColumnText';
  CenterBodyFontSize?: Maybe<Enum_Componentblocksthreecolumntext_Centerbodyfontsize>;
  CenterContent?: Maybe<Scalars['JSON']['output']>;
  CenterHeadingFontSize?: Maybe<Enum_Componentblocksthreecolumntext_Centerheadingfontsize>;
  CenterImage?: Maybe<UploadFile>;
  LeftBodyFontSize?: Maybe<Enum_Componentblocksthreecolumntext_Leftbodyfontsize>;
  LeftContent?: Maybe<Scalars['JSON']['output']>;
  LeftHeadingFontSize?: Maybe<Enum_Componentblocksthreecolumntext_Leftheadingfontsize>;
  LeftImage?: Maybe<UploadFile>;
  RightBodyFontSize?: Maybe<Enum_Componentblocksthreecolumntext_Rightbodyfontsize>;
  RightContent?: Maybe<Scalars['JSON']['output']>;
  RightHeadingFontSize?: Maybe<Enum_Componentblocksthreecolumntext_Rightheadingfontsize>;
  RightImage?: Maybe<UploadFile>;
  ShowNumbers?: Maybe<Scalars['Boolean']['output']>;
  ThreeColumnBackground?: Maybe<ComponentSharedBackground>;
  ThreeColumnDescription?: Maybe<Scalars['JSON']['output']>;
  ThreeColumnDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  ThreeColumnTitle?: Maybe<Scalars['String']['output']>;
  ThreeColumnVariant?: Maybe<Enum_Componentblocksthreecolumntext_Threecolumnvariant>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksThreeSteps = {
  __typename?: 'ComponentBlocksThreeSteps';
  BlockCta?: Maybe<ComponentBlocksButton>;
  CTAFooter?: Maybe<Scalars['String']['output']>;
  CTAIntro?: Maybe<Scalars['JSON']['output']>;
  HideArrows?: Maybe<Scalars['Boolean']['output']>;
  ShowNumbers?: Maybe<Scalars['Boolean']['output']>;
  StepImageBackground?: Maybe<Scalars['Boolean']['output']>;
  Steps?: Maybe<Array<Maybe<ComponentBlocksStepItem>>>;
  ThreeStepBlurb?: Maybe<Scalars['JSON']['output']>;
  ThreeStepDescription?: Maybe<Scalars['String']['output']>;
  ThreeStepTitle?: Maybe<Scalars['String']['output']>;
  ThreeStepsBackground?: Maybe<ComponentSharedBackground>;
  ThreeStepsDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksThreeStepsStepsArgs = {
  filters?: InputMaybe<ComponentBlocksStepItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksTimeline = {
  __typename?: 'ComponentBlocksTimeline';
  Body?: Maybe<Scalars['JSON']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Year?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBlocksTimelineFiltersInput = {
  Body?: InputMaybe<JsonFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  Year?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksTimelineFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksTimelineFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksTimelineFiltersInput>>>;
};

export type ComponentBlocksTimelineInput = {
  Body?: InputMaybe<Scalars['JSON']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Year?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBlocksTwoColumnTextImageBlock = {
  __typename?: 'ComponentBlocksTwoColumnTextImageBlock';
  Image?: Maybe<UploadFile>;
  ImageAlignment?: Maybe<Enum_Componentblockstwocolumntextimageblock_Imagealignment>;
  ImageBorder?: Maybe<Scalars['Boolean']['output']>;
  ImageColRight?: Maybe<Scalars['Boolean']['output']>;
  ImageColumnSize?: Maybe<Enum_Componentblockstwocolumntextimageblock_Imagecolumnsize>;
  ItemSpacing?: Maybe<Enum_Componentblockstwocolumntextimageblock_Itemspacing>;
  RoundImageCorners?: Maybe<Scalars['Boolean']['output']>;
  TextColumnSize?: Maybe<Enum_Componentblockstwocolumntextimageblock_Textcolumnsize>;
  TwoColumnBackground?: Maybe<ComponentSharedBackground>;
  TwoColumnBlurb?: Maybe<Scalars['JSON']['output']>;
  TwoColumnBody?: Maybe<Scalars['JSON']['output']>;
  TwoColumnDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  TwoColumnTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentCalculatorCalculatorHighlight = {
  __typename?: 'ComponentCalculatorCalculatorHighlight';
  CalcHighlightBlurb?: Maybe<Scalars['JSON']['output']>;
  CalcHighlightTitle?: Maybe<Scalars['String']['output']>;
  CalculatorHighlightBackground?: Maybe<ComponentSharedBackground>;
  CalculatorHighlightDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  HightlightCalculator?: Maybe<LoanCalculator>;
  LoanCalculator: Array<Maybe<LoanCalculator>>;
  LoanCalculator_connection?: Maybe<LoanCalculatorRelationResponseCollection>;
  id: Scalars['ID']['output'];
};

export type ComponentCalculatorCalculatorHighlightLoanCalculatorArgs = {
  filters?: InputMaybe<LoanCalculatorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCalculatorCalculatorHighlightLoanCalculator_ConnectionArgs = {
  filters?: InputMaybe<LoanCalculatorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDataHomepageContent = {
  __typename?: 'ComponentDataHomepageContent';
  BmeCards?: Maybe<Array<Maybe<ComponentDataHomepageMadeEasyCard>>>;
  BmeHeadingAccent?: Maybe<Scalars['String']['output']>;
  BmeHeadingMain?: Maybe<Scalars['String']['output']>;
  BmeSubtitle?: Maybe<Scalars['String']['output']>;
  HiwHeadingAccent?: Maybe<Scalars['String']['output']>;
  HiwHeadingMain?: Maybe<Scalars['String']['output']>;
  HiwProfileCardButtonText?: Maybe<Scalars['String']['output']>;
  HiwProfileCardRows?: Maybe<Array<Maybe<ComponentDataHomepageProfileRow>>>;
  HiwProfileCardTitle?: Maybe<Scalars['String']['output']>;
  HiwSectionLabel?: Maybe<Scalars['String']['output']>;
  HiwSteps?: Maybe<Array<Maybe<ComponentDataHomepageStep>>>;
  HiwSubheading?: Maybe<Scalars['String']['output']>;
  LtsHeadingAccent?: Maybe<Scalars['String']['output']>;
  LtsHeadingMain?: Maybe<Scalars['String']['output']>;
  LtsSectionLabel?: Maybe<Scalars['String']['output']>;
  LtsSubtitle?: Maybe<Scalars['String']['output']>;
  TstHeadingAccent?: Maybe<Scalars['String']['output']>;
  TstHeadingMain?: Maybe<Scalars['String']['output']>;
  TstQuoteText?: Maybe<Scalars['String']['output']>;
  TstSectionLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentDataHomepageContentBmeCardsArgs = {
  filters?: InputMaybe<ComponentDataHomepageMadeEasyCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDataHomepageContentHiwProfileCardRowsArgs = {
  filters?: InputMaybe<ComponentDataHomepageProfileRowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDataHomepageContentHiwStepsArgs = {
  filters?: InputMaybe<ComponentDataHomepageStepFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDataHomepageContentInput = {
  BmeCards?: InputMaybe<Array<InputMaybe<ComponentDataHomepageMadeEasyCardInput>>>;
  BmeHeadingAccent?: InputMaybe<Scalars['String']['input']>;
  BmeHeadingMain?: InputMaybe<Scalars['String']['input']>;
  BmeSubtitle?: InputMaybe<Scalars['String']['input']>;
  HiwHeadingAccent?: InputMaybe<Scalars['String']['input']>;
  HiwHeadingMain?: InputMaybe<Scalars['String']['input']>;
  HiwProfileCardButtonText?: InputMaybe<Scalars['String']['input']>;
  HiwProfileCardRows?: InputMaybe<Array<InputMaybe<ComponentDataHomepageProfileRowInput>>>;
  HiwProfileCardTitle?: InputMaybe<Scalars['String']['input']>;
  HiwSectionLabel?: InputMaybe<Scalars['String']['input']>;
  HiwSteps?: InputMaybe<Array<InputMaybe<ComponentDataHomepageStepInput>>>;
  HiwSubheading?: InputMaybe<Scalars['String']['input']>;
  LtsHeadingAccent?: InputMaybe<Scalars['String']['input']>;
  LtsHeadingMain?: InputMaybe<Scalars['String']['input']>;
  LtsSectionLabel?: InputMaybe<Scalars['String']['input']>;
  LtsSubtitle?: InputMaybe<Scalars['String']['input']>;
  TstHeadingAccent?: InputMaybe<Scalars['String']['input']>;
  TstHeadingMain?: InputMaybe<Scalars['String']['input']>;
  TstQuoteText?: InputMaybe<Scalars['String']['input']>;
  TstSectionLabel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentDataHomepageMadeEasyCard = {
  __typename?: 'ComponentDataHomepageMadeEasyCard';
  Body: Scalars['String']['output'];
  Icon?: Maybe<UploadFile>;
  Title: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentDataHomepageMadeEasyCardFiltersInput = {
  Body?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentDataHomepageMadeEasyCardFiltersInput>>>;
  not?: InputMaybe<ComponentDataHomepageMadeEasyCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentDataHomepageMadeEasyCardFiltersInput>>>;
};

export type ComponentDataHomepageMadeEasyCardInput = {
  Body?: InputMaybe<Scalars['String']['input']>;
  Icon?: InputMaybe<Scalars['ID']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentDataHomepageProfileRow = {
  __typename?: 'ComponentDataHomepageProfileRow';
  Icon?: Maybe<UploadFile>;
  Label: Scalars['String']['output'];
  Value: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentDataHomepageProfileRowFiltersInput = {
  Label?: InputMaybe<StringFilterInput>;
  Value?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentDataHomepageProfileRowFiltersInput>>>;
  not?: InputMaybe<ComponentDataHomepageProfileRowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentDataHomepageProfileRowFiltersInput>>>;
};

export type ComponentDataHomepageProfileRowInput = {
  Icon?: InputMaybe<Scalars['ID']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  Value?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentDataHomepageStep = {
  __typename?: 'ComponentDataHomepageStep';
  Body: Scalars['String']['output'];
  Icon?: Maybe<UploadFile>;
  Title: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentDataHomepageStepFiltersInput = {
  Body?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentDataHomepageStepFiltersInput>>>;
  not?: InputMaybe<ComponentDataHomepageStepFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentDataHomepageStepFiltersInput>>>;
};

export type ComponentDataHomepageStepInput = {
  Body?: InputMaybe<Scalars['String']['input']>;
  Icon?: InputMaybe<Scalars['ID']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentDataOfficeLocation = {
  __typename?: 'ComponentDataOfficeLocation';
  MapLocation?: Maybe<Scalars['String']['output']>;
  OfficeAddress?: Maybe<Scalars['String']['output']>;
  OfficeBlurb?: Maybe<Scalars['String']['output']>;
  OfficeImage?: Maybe<UploadFile>;
  OfficeName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentLoanLoanComparison = {
  __typename?: 'ComponentLoanLoanComparison';
  DefaultLoanAmount?: Maybe<Scalars['Int']['output']>;
  DefaultProductType?: Maybe<Enum_Componentloanloancomparison_Defaultproducttype>;
  DefaultPurpose?: Maybe<Enum_Componentloanloancomparison_Defaultpurpose>;
  DefaultSort?: Maybe<Enum_Componentloanloancomparison_Defaultsort>;
  DefaultView?: Maybe<Enum_Componentloanloancomparison_Defaultview>;
  Description?: Maybe<Scalars['JSON']['output']>;
  IncludeLenderTiers?: Maybe<Scalars['Boolean']['output']>;
  Lenders: Array<Maybe<Lender>>;
  Lenders_connection?: Maybe<LenderRelationResponseCollection>;
  LoanComparisonBackground?: Maybe<ComponentSharedBackground>;
  LoanComparisonDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  LoanComparisonTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentLoanLoanComparisonLendersArgs = {
  filters?: InputMaybe<LenderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentLoanLoanComparisonLenders_ConnectionArgs = {
  filters?: InputMaybe<LenderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentLoanLoanHighlight = {
  __typename?: 'ComponentLoanLoanHighlight';
  HighlightDefaultLoanAmount?: Maybe<Scalars['Int']['output']>;
  HighlightDefaultProductType?: Maybe<Enum_Componentloanloanhighlight_Highlightdefaultproducttype>;
  HighlightDefaultPurpose?: Maybe<Enum_Componentloanloanhighlight_Highlightdefaultpurpose>;
  LenderTiers: Array<Maybe<LenderTier>>;
  LenderTiers_connection?: Maybe<LenderTierRelationResponseCollection>;
  LoanHighlightBackground?: Maybe<ComponentSharedBackground>;
  LoanHighlightDescription?: Maybe<Scalars['JSON']['output']>;
  LoanHighlightDisplayOptions?: Maybe<ComponentSharedDisplayOptions>;
  LoanHighlightTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentLoanLoanHighlightLenderTiersArgs = {
  filters?: InputMaybe<LenderTierFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentLoanLoanHighlightLenderTiers_ConnectionArgs = {
  filters?: InputMaybe<LenderTierFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMenuMainMenuSettings = {
  __typename?: 'ComponentMenuMainMenuSettings';
  AutomaticPagesMenuLabel?: Maybe<Scalars['String']['output']>;
  AutomaticPagesMenuMaxDepth: Scalars['Int']['output'];
  AutomaticResourcesMenuLabel?: Maybe<Scalars['String']['output']>;
  ShowAutomaticPagesMenu: Scalars['Boolean']['output'];
  ShowAutomaticResourcesMenu: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentMenuMenuLinkPage = {
  __typename?: 'ComponentMenuMenuLinkPage';
  CustomLabel?: Maybe<Scalars['String']['output']>;
  Page?: Maybe<Page>;
  PageAnchor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentMenuMenuLinkResource = {
  __typename?: 'ComponentMenuMenuLinkResource';
  CustomLabel?: Maybe<Scalars['String']['output']>;
  PageAnchor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  resource_article?: Maybe<ResourceArticle>;
};

export type ComponentMenuMenuLinkResourceCategory = {
  __typename?: 'ComponentMenuMenuLinkResourceCategory';
  CustomLabel?: Maybe<Scalars['String']['output']>;
  PageAnchor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  resource_category?: Maybe<ResourceCategory>;
};

export type ComponentMenuMenuLinkUrl = {
  __typename?: 'ComponentMenuMenuLinkUrl';
  CustomLabel: Scalars['String']['output'];
  Url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentMenuMenuLinkUrlFiltersInput = {
  CustomLabel?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentMenuMenuLinkUrlFiltersInput>>>;
  not?: InputMaybe<ComponentMenuMenuLinkUrlFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMenuMenuLinkUrlFiltersInput>>>;
};

export type ComponentMenuMenuLinkUrlInput = {
  CustomLabel?: InputMaybe<Scalars['String']['input']>;
  Url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMenuMenuSubMenu = {
  __typename?: 'ComponentMenuMenuSubMenu';
  CustomLabel?: Maybe<Scalars['String']['output']>;
  SubMenu?: Maybe<Menu>;
  id: Scalars['ID']['output'];
};

export type ComponentRepeatableProsAndConsRow = {
  __typename?: 'ComponentRepeatableProsAndConsRow';
  Con?: Maybe<Array<Maybe<ComponentBlocksConTableList>>>;
  FinanceType?: Maybe<Scalars['String']['output']>;
  Pros?: Maybe<Array<Maybe<ComponentBlocksProTableList>>>;
  id: Scalars['ID']['output'];
};

export type ComponentRepeatableProsAndConsRowConArgs = {
  filters?: InputMaybe<ComponentBlocksConTableListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentRepeatableProsAndConsRowProsArgs = {
  filters?: InputMaybe<ComponentBlocksProTableListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentRepeatableProsAndConsRowFiltersInput = {
  Con?: InputMaybe<ComponentBlocksConTableListFiltersInput>;
  FinanceType?: InputMaybe<StringFilterInput>;
  Pros?: InputMaybe<ComponentBlocksProTableListFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentRepeatableProsAndConsRowFiltersInput>>>;
  not?: InputMaybe<ComponentRepeatableProsAndConsRowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentRepeatableProsAndConsRowFiltersInput>>>;
};

export type ComponentSharedArticleExplainer = {
  __typename?: 'ComponentSharedArticleExplainer';
  Items?: Maybe<Array<Maybe<ComponentSharedArticleExplainerItem>>>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentSharedArticleExplainerItemsArgs = {
  filters?: InputMaybe<ComponentSharedArticleExplainerItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedArticleExplainerFiltersInput = {
  Items?: InputMaybe<ComponentSharedArticleExplainerItemFiltersInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedArticleExplainerFiltersInput>>>;
  not?: InputMaybe<ComponentSharedArticleExplainerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedArticleExplainerFiltersInput>>>;
};

export type ComponentSharedArticleExplainerInput = {
  Items?: InputMaybe<Array<InputMaybe<ComponentSharedArticleExplainerItemInput>>>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedArticleExplainerItem = {
  __typename?: 'ComponentSharedArticleExplainerItem';
  BoldText?: Maybe<Scalars['String']['output']>;
  Text: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentSharedArticleExplainerItemFiltersInput = {
  BoldText?: InputMaybe<StringFilterInput>;
  Text?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedArticleExplainerItemFiltersInput>>>;
  not?: InputMaybe<ComponentSharedArticleExplainerItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedArticleExplainerItemFiltersInput>>>;
};

export type ComponentSharedArticleExplainerItemInput = {
  BoldText?: InputMaybe<Scalars['String']['input']>;
  Text?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedArticleSidebarCta = {
  __typename?: 'ComponentSharedArticleSidebarCta';
  ButtonText?: Maybe<Scalars['String']['output']>;
  ButtonUrl?: Maybe<Scalars['String']['output']>;
  Items?: Maybe<Array<Maybe<ComponentSharedArticleSidebarCtaItem>>>;
  PhoneImage?: Maybe<UploadFile>;
  PhoneNumber?: Maybe<Scalars['String']['output']>;
  ShareFacebook?: Maybe<Scalars['Boolean']['output']>;
  ShareInstagram?: Maybe<Scalars['Boolean']['output']>;
  ShareLinkedIn?: Maybe<Scalars['Boolean']['output']>;
  ShareMail?: Maybe<Scalars['Boolean']['output']>;
  ShareX?: Maybe<Scalars['Boolean']['output']>;
  ShowShareLabels?: Maybe<Scalars['Boolean']['output']>;
  ShowShareLinks?: Maybe<Scalars['Boolean']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentSharedArticleSidebarCtaItemsArgs = {
  filters?: InputMaybe<ComponentSharedArticleSidebarCtaItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedArticleSidebarCtaFiltersInput = {
  ButtonText?: InputMaybe<StringFilterInput>;
  ButtonUrl?: InputMaybe<StringFilterInput>;
  Items?: InputMaybe<ComponentSharedArticleSidebarCtaItemFiltersInput>;
  PhoneNumber?: InputMaybe<StringFilterInput>;
  ShareFacebook?: InputMaybe<BooleanFilterInput>;
  ShareInstagram?: InputMaybe<BooleanFilterInput>;
  ShareLinkedIn?: InputMaybe<BooleanFilterInput>;
  ShareMail?: InputMaybe<BooleanFilterInput>;
  ShareX?: InputMaybe<BooleanFilterInput>;
  ShowShareLabels?: InputMaybe<BooleanFilterInput>;
  ShowShareLinks?: InputMaybe<BooleanFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedArticleSidebarCtaFiltersInput>>>;
  not?: InputMaybe<ComponentSharedArticleSidebarCtaFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedArticleSidebarCtaFiltersInput>>>;
};

export type ComponentSharedArticleSidebarCtaInput = {
  ButtonText?: InputMaybe<Scalars['String']['input']>;
  ButtonUrl?: InputMaybe<Scalars['String']['input']>;
  Items?: InputMaybe<Array<InputMaybe<ComponentSharedArticleSidebarCtaItemInput>>>;
  PhoneImage?: InputMaybe<Scalars['ID']['input']>;
  PhoneNumber?: InputMaybe<Scalars['String']['input']>;
  ShareFacebook?: InputMaybe<Scalars['Boolean']['input']>;
  ShareInstagram?: InputMaybe<Scalars['Boolean']['input']>;
  ShareLinkedIn?: InputMaybe<Scalars['Boolean']['input']>;
  ShareMail?: InputMaybe<Scalars['Boolean']['input']>;
  ShareX?: InputMaybe<Scalars['Boolean']['input']>;
  ShowShareLabels?: InputMaybe<Scalars['Boolean']['input']>;
  ShowShareLinks?: InputMaybe<Scalars['Boolean']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedArticleSidebarCtaItem = {
  __typename?: 'ComponentSharedArticleSidebarCtaItem';
  BoldText?: Maybe<Scalars['String']['output']>;
  Text: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentSharedArticleSidebarCtaItemFiltersInput = {
  BoldText?: InputMaybe<StringFilterInput>;
  Text?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedArticleSidebarCtaItemFiltersInput>>>;
  not?: InputMaybe<ComponentSharedArticleSidebarCtaItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedArticleSidebarCtaItemFiltersInput>>>;
};

export type ComponentSharedArticleSidebarCtaItemInput = {
  BoldText?: InputMaybe<Scalars['String']['input']>;
  Text?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedAward = {
  __typename?: 'ComponentSharedAward';
  Alt: Scalars['String']['output'];
  Image: UploadFile;
  Url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentSharedAwardFiltersInput = {
  Alt?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedAwardFiltersInput>>>;
  not?: InputMaybe<ComponentSharedAwardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedAwardFiltersInput>>>;
};

export type ComponentSharedAwardInput = {
  Alt?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  Url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedBackground = {
  __typename?: 'ComponentSharedBackground';
  AnimateOrbs?: Maybe<Scalars['Boolean']['output']>;
  BackgroundColor?: Maybe<Enum_Componentsharedbackground_Backgroundcolor>;
  BackgroundOrbs?: Maybe<Enum_Componentsharedbackground_Backgroundorbs>;
  BackgroundOrbsOverflow?: Maybe<Scalars['Boolean']['output']>;
  ContainedBackground?: Maybe<Scalars['Boolean']['output']>;
  FadeInOutContent?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentSharedBackgroundFiltersInput = {
  AnimateOrbs?: InputMaybe<BooleanFilterInput>;
  BackgroundColor?: InputMaybe<StringFilterInput>;
  BackgroundOrbs?: InputMaybe<StringFilterInput>;
  BackgroundOrbsOverflow?: InputMaybe<BooleanFilterInput>;
  ContainedBackground?: InputMaybe<BooleanFilterInput>;
  FadeInOutContent?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedBackgroundFiltersInput>>>;
  not?: InputMaybe<ComponentSharedBackgroundFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedBackgroundFiltersInput>>>;
};

export type ComponentSharedBackgroundInput = {
  AnimateOrbs?: InputMaybe<Scalars['Boolean']['input']>;
  BackgroundColor?: InputMaybe<Enum_Componentsharedbackground_Backgroundcolor>;
  BackgroundOrbs?: InputMaybe<Enum_Componentsharedbackground_Backgroundorbs>;
  BackgroundOrbsOverflow?: InputMaybe<Scalars['Boolean']['input']>;
  ContainedBackground?: InputMaybe<Scalars['Boolean']['input']>;
  FadeInOutContent?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedDisplayOptions = {
  __typename?: 'ComponentSharedDisplayOptions';
  CenterAlignImages?: Maybe<Scalars['Boolean']['output']>;
  CenterAlignParagraphs?: Maybe<Scalars['Boolean']['output']>;
  CenterAlignTitles?: Maybe<Scalars['Boolean']['output']>;
  ContentsWidth?: Maybe<Enum_Componentshareddisplayoptions_Contentswidth>;
  PaddingBottom?: Maybe<Enum_Componentshareddisplayoptions_Paddingbottom>;
  PaddingInline?: Maybe<Enum_Componentshareddisplayoptions_Paddinginline>;
  PaddingTop?: Maybe<Enum_Componentshareddisplayoptions_Paddingtop>;
  id: Scalars['ID']['output'];
};

export type ComponentSharedDisplayOptionsFiltersInput = {
  CenterAlignImages?: InputMaybe<BooleanFilterInput>;
  CenterAlignParagraphs?: InputMaybe<BooleanFilterInput>;
  CenterAlignTitles?: InputMaybe<BooleanFilterInput>;
  ContentsWidth?: InputMaybe<StringFilterInput>;
  PaddingBottom?: InputMaybe<StringFilterInput>;
  PaddingInline?: InputMaybe<StringFilterInput>;
  PaddingTop?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedDisplayOptionsFiltersInput>>>;
  not?: InputMaybe<ComponentSharedDisplayOptionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedDisplayOptionsFiltersInput>>>;
};

export type ComponentSharedDisplayOptionsInput = {
  CenterAlignImages?: InputMaybe<Scalars['Boolean']['input']>;
  CenterAlignParagraphs?: InputMaybe<Scalars['Boolean']['input']>;
  CenterAlignTitles?: InputMaybe<Scalars['Boolean']['input']>;
  ContentsWidth?: InputMaybe<Enum_Componentshareddisplayoptions_Contentswidth>;
  PaddingBottom?: InputMaybe<Enum_Componentshareddisplayoptions_Paddingbottom>;
  PaddingInline?: InputMaybe<Enum_Componentshareddisplayoptions_Paddinginline>;
  PaddingTop?: InputMaybe<Enum_Componentshareddisplayoptions_Paddingtop>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedFooterLogo = {
  __typename?: 'ComponentSharedFooterLogo';
  Alt: Scalars['String']['output'];
  Image: UploadFile;
  Url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentSharedFooterLogoFiltersInput = {
  Alt?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedFooterLogoFiltersInput>>>;
  not?: InputMaybe<ComponentSharedFooterLogoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedFooterLogoFiltersInput>>>;
};

export type ComponentSharedFooterLogoInput = {
  Alt?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  Url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedOpenGraph = {
  __typename?: 'ComponentSharedOpenGraph';
  id: Scalars['ID']['output'];
  og_description: Scalars['String']['output'];
  og_image?: Maybe<UploadFile>;
  og_title: Scalars['String']['output'];
  og_type?: Maybe<Scalars['String']['output']>;
  og_url?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedOpenGraphFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedOpenGraphFiltersInput>>>;
  not?: InputMaybe<ComponentSharedOpenGraphFiltersInput>;
  og_description?: InputMaybe<StringFilterInput>;
  og_title?: InputMaybe<StringFilterInput>;
  og_type?: InputMaybe<StringFilterInput>;
  og_url?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedOpenGraphFiltersInput>>>;
};

export type ComponentSharedOpenGraphInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  og_description?: InputMaybe<Scalars['String']['input']>;
  og_image?: InputMaybe<Scalars['ID']['input']>;
  og_title?: InputMaybe<Scalars['String']['input']>;
  og_type?: InputMaybe<Scalars['String']['input']>;
  og_url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedSeo = {
  __typename?: 'ComponentSharedSeo';
  canonicalURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  metaDescription: Scalars['String']['output'];
  metaImage?: Maybe<UploadFile>;
  metaRobots?: Maybe<Scalars['String']['output']>;
  metaTitle: Scalars['String']['output'];
  metaViewport?: Maybe<Scalars['String']['output']>;
  openGraph?: Maybe<ComponentSharedOpenGraph>;
  structuredData?: Maybe<Scalars['JSON']['output']>;
};

export type ComponentSharedSeoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
  canonicalURL?: InputMaybe<StringFilterInput>;
  keywords?: InputMaybe<StringFilterInput>;
  metaDescription?: InputMaybe<StringFilterInput>;
  metaRobots?: InputMaybe<StringFilterInput>;
  metaTitle?: InputMaybe<StringFilterInput>;
  metaViewport?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedSeoFiltersInput>;
  openGraph?: InputMaybe<ComponentSharedOpenGraphFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
  structuredData?: InputMaybe<JsonFilterInput>;
};

export type ComponentSharedSeoInput = {
  canonicalURL?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaImage?: InputMaybe<Scalars['ID']['input']>;
  metaRobots?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaViewport?: InputMaybe<Scalars['String']['input']>;
  openGraph?: InputMaybe<ComponentSharedOpenGraphInput>;
  structuredData?: InputMaybe<Scalars['JSON']['input']>;
};

export type ComponentSharedSideBarContent = {
  __typename?: 'ComponentSharedSideBarContent';
  ArticleSidebarCta?: Maybe<ComponentSharedArticleSidebarCta>;
  AuthorCard?: Maybe<ComponentBlocksAuthorDetails>;
  LeadFunnel?: Maybe<ComponentBlocksFunnel>;
  MetricHighlight?: Maybe<Array<Maybe<ComponentBlocksMetricHighlight>>>;
  ShowJumpLinks?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentSharedSideBarContentMetricHighlightArgs = {
  filters?: InputMaybe<ComponentBlocksMetricHighlightFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedSideBarContentFiltersInput = {
  ArticleSidebarCta?: InputMaybe<ComponentSharedArticleSidebarCtaFiltersInput>;
  AuthorCard?: InputMaybe<ComponentBlocksAuthorDetailsFiltersInput>;
  LeadFunnel?: InputMaybe<ComponentBlocksFunnelFiltersInput>;
  MetricHighlight?: InputMaybe<ComponentBlocksMetricHighlightFiltersInput>;
  ShowJumpLinks?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSideBarContentFiltersInput>>>;
  not?: InputMaybe<ComponentSharedSideBarContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSideBarContentFiltersInput>>>;
};

export type ComponentSharedSideBarContentInput = {
  ArticleSidebarCta?: InputMaybe<ComponentSharedArticleSidebarCtaInput>;
  AuthorCard?: InputMaybe<ComponentBlocksAuthorDetailsInput>;
  LeadFunnel?: InputMaybe<ComponentBlocksFunnelInput>;
  MetricHighlight?: InputMaybe<Array<InputMaybe<ComponentBlocksMetricHighlightInput>>>;
  ShowJumpLinks?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedSiteBanner = {
  __typename?: 'ComponentSharedSiteBanner';
  BannerDismissable: Scalars['Boolean']['output'];
  BannerLink?: Maybe<ComponentMenuMenuLinkUrl>;
  BannerType: Enum_Componentsharedsitebanner_Bannertype;
  MessageBlurb?: Maybe<Scalars['String']['output']>;
  MessageHeading?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentSharedSiteBannerFiltersInput = {
  BannerDismissable?: InputMaybe<BooleanFilterInput>;
  BannerLink?: InputMaybe<ComponentMenuMenuLinkUrlFiltersInput>;
  BannerType?: InputMaybe<StringFilterInput>;
  MessageBlurb?: InputMaybe<StringFilterInput>;
  MessageHeading?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSiteBannerFiltersInput>>>;
  not?: InputMaybe<ComponentSharedSiteBannerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSiteBannerFiltersInput>>>;
};

export type ComponentSharedSiteBannerInput = {
  BannerDismissable?: InputMaybe<Scalars['Boolean']['input']>;
  BannerLink?: InputMaybe<ComponentMenuMenuLinkUrlInput>;
  BannerType?: InputMaybe<Enum_Componentsharedsitebanner_Bannertype>;
  MessageBlurb?: InputMaybe<Scalars['String']['input']>;
  MessageHeading?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedSocialLink = {
  __typename?: 'ComponentSharedSocialLink';
  Platform: Enum_Componentsharedsociallink_Platform;
  Url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentSharedSocialLinkFiltersInput = {
  Platform?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSocialLinkFiltersInput>>>;
  not?: InputMaybe<ComponentSharedSocialLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSocialLinkFiltersInput>>>;
};

export type ComponentSharedSocialLinkInput = {
  Platform?: InputMaybe<Enum_Componentsharedsociallink_Platform>;
  Url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Contact = {
  __typename?: 'Contact';
  Blocks?: Maybe<Array<Maybe<ContactBlocksDynamicZone>>>;
  ContactBlurb?: Maybe<Scalars['JSON']['output']>;
  ContactByPhonePrompt?: Maybe<Scalars['String']['output']>;
  ContactFormBackground?: Maybe<ComponentSharedBackground>;
  ContactHeroBlurb?: Maybe<Scalars['JSON']['output']>;
  ContactHeroImage?: Maybe<UploadFile>;
  ContactPageSeo?: Maybe<ComponentSharedSeo>;
  Title: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactBlocksDynamicZone =
  | ComponentBlocksActionBlock
  | ComponentBlocksAdditionalFeatures
  | ComponentBlocksAuthorDetails
  | ComponentBlocksBreak
  | ComponentBlocksCalculatorGrid
  | ComponentBlocksCta
  | ComponentBlocksFaqList
  | ComponentBlocksFunnel
  | ComponentBlocksHighlightBlock
  | ComponentBlocksHtml
  | ComponentBlocksImage
  | ComponentBlocksInfoTilesBlock
  | ComponentBlocksLatestResourcesBlock
  | ComponentBlocksLenderList
  | ComponentBlocksLoanCalculators
  | ComponentBlocksMetricHighlight
  | ComponentBlocksPageSeparator
  | ComponentBlocksPlatformReviewsBlock
  | ComponentBlocksPostcard
  | ComponentBlocksProductFeatures
  | ComponentBlocksProsAndConsTable
  | ComponentBlocksProsAndConsTableV2
  | ComponentBlocksRelatedArticles
  | ComponentBlocksRelatedBlogs
  | ComponentBlocksStepsList
  | ComponentBlocksTableWidget
  | ComponentBlocksText
  | ComponentBlocksThreeColumnText
  | ComponentBlocksThreeSteps
  | ComponentBlocksTwoColumnTextImageBlock
  | ComponentCalculatorCalculatorHighlight
  | ComponentLoanLoanComparison
  | ComponentLoanLoanHighlight
  | Error;

export type ContactInput = {
  Blocks?: InputMaybe<Array<Scalars['ContactBlocksDynamicZoneInput']['input']>>;
  ContactBlurb?: InputMaybe<Scalars['JSON']['input']>;
  ContactByPhonePrompt?: InputMaybe<Scalars['String']['input']>;
  ContactFormBackground?: InputMaybe<ComponentSharedBackgroundInput>;
  ContactHeroBlurb?: InputMaybe<Scalars['JSON']['input']>;
  ContactHeroImage?: InputMaybe<Scalars['ID']['input']>;
  ContactPageSeo?: InputMaybe<ComponentSharedSeoInput>;
  Title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteMutationResponse = {
  __typename?: 'DeleteMutationResponse';
  documentId: Scalars['ID']['output'];
};

export enum Enum_Componentblocksactionblock_Asideposition {
  Left = 'Left',
  None = 'None',
  Right = 'Right',
}

export enum Enum_Componentblockscta_Ctaalignment {
  Center = 'center',
  Left = 'left',
  Right = 'right',
}

export enum Enum_Componentblockscta_Ctabuttonstyle {
  Gradient = 'Gradient',
  Primary = 'Primary',
}

export enum Enum_Componentblockscta_Ctaheromediadisplay {
  Contain = 'contain',
  Cover = 'cover',
}

export enum Enum_Componentblocksfaqlist_Faqliststyle {
  Accordion = 'Accordion',
  Plain = 'Plain',
}

export enum Enum_Componentblocksfaqlist_Variant {
  Plain = 'Plain',
  WithGrouping = 'WithGrouping',
}

export enum Enum_Componentblocksfunnel_Funnelvariant {
  Block = 'Block',
  NewHomepage = 'NewHomepage',
  Popup = 'Popup',
}

export enum Enum_Componentblocksheroform_Heromediadisplay {
  Contain = 'contain',
  Cover = 'cover',
}

export enum Enum_Componentblockshighlightblock_Highlightvariant {
  Brand = 'Brand',
  Primary = 'Primary',
  Secondary = 'Secondary',
}

export enum Enum_Componentblockshomepageheroform_Heromediadisplay {
  Contain = 'contain',
  Cover = 'cover',
}

export enum Enum_Componentblocksinfotilesrow_Rowcolumns {
  Auto = 'auto',
}

export enum Enum_Componentblocksinfotile_Tilesize {
  Large = 'large',
  Small = 'small',
}

export enum Enum_Componentblockslandingpagehero_Landingheromediadisplay {
  Contain = 'contain',
  Cover = 'cover',
  Hero = 'hero',
}

export enum Enum_Componentblocksloancalculators_Calculatortype {
  Amortisation = 'Amortisation',
  BorrowingPower = 'BorrowingPower',
  BusinessLoan = 'BusinessLoan',
  BusinessOverdraft = 'BusinessOverdraft',
  CarDepreciation = 'CarDepreciation',
  CarLoan = 'CarLoan',
  ChattelMortgage = 'ChattelMortgage',
  CommercialPropertyLoan = 'CommercialPropertyLoan',
  ConstructionLoan = 'ConstructionLoan',
  EarlyRepayment = 'EarlyRepayment',
  EquipmentFinance = 'EquipmentFinance',
  FactorToApr = 'FactorToApr',
  FinanceLease = 'FinanceLease',
  GuarantorLoan = 'GuarantorLoan',
  HirePurchase = 'HirePurchase',
  LeaseVsLoan = 'LeaseVsLoan',
  LineOfCredit = 'LineOfCredit',
  LoanRepayment = 'LoanRepayment',
  PayslipEstimator = 'PayslipEstimator',
}

export enum Enum_Componentblocksplatformreviewsblock_Reviewtype {
  Broker = 'broker',
  Customer = 'customer',
}

export enum Enum_Componentblocksproductfeatures_Componentbackgroundcolour {
  Primary = 'primary',
  Purple = 'purple',
  PurpleLight = 'purple_light',
  White = 'white',
}

export enum Enum_Componentblocksproductfeatures_Productfeaturesimagealignment {
  Center = 'Center',
  Top = 'Top',
}

export enum Enum_Componentblocksproductfeatures_Productfeaturesimagecolumnsize {
  Percent25 = 'percent25',
  Percent30 = 'percent30',
  Percent33 = 'percent33',
  Percent35 = 'percent35',
  Percent40 = 'percent40',
  Percent45 = 'percent45',
  Percent50 = 'percent50',
}

export enum Enum_Componentblocksproductfeatures_Productfeaturesitemspacing {
  Around = 'around',
  Between = 'between',
}

export enum Enum_Componentblocksproductfeatures_Productfeaturestextcolumnsize {
  Auto = 'auto',
  Percent25 = 'percent25',
  Percent30 = 'percent30',
  Percent33 = 'percent33',
  Percent35 = 'percent35',
  Percent40 = 'percent40',
  Percent45 = 'percent45',
  Percent50 = 'percent50',
  Percent55 = 'percent55',
  Percent60 = 'percent60',
  Percent65 = 'percent65',
  Percent70 = 'percent70',
  Percent75 = 'percent75',
}

export enum Enum_Componentblocksstepslist_Stepsliststyle {
  BlueList = 'BlueList',
  Card = 'Card',
  CardRow = 'CardRow',
  ImageTable = 'ImageTable',
  NumberedTable = 'NumberedTable',
  Plain = 'Plain',
}

export enum Enum_Componentblockstablecellitem_Align {
  Center = 'center',
  Left = 'left',
  Right = 'right',
}

export enum Enum_Componentblockstablecellitem_Fontsize {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
}

export enum Enum_Componentblockstablecellitem_Verticalalign {
  Bottom = 'bottom',
  Middle = 'middle',
  Top = 'top',
}

export enum Enum_Componentblockstableheadingitem_Align {
  Center = 'center',
  Left = 'left',
  Right = 'right',
}

export enum Enum_Componentblockstableheadingitem_Fontsize {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
}

export enum Enum_Componentblockstablewidget_Columnwidthpreset {
  Auto = 'auto',
  C1_100 = 'c1_100',
  C2_25_75 = 'c2_25_75',
  C2_33_67 = 'c2_33_67',
  C2_40_60 = 'c2_40_60',
  C2_50_50 = 'c2_50_50',
  C2_60_40 = 'c2_60_40',
  C2_67_33 = 'c2_67_33',
  C2_75_25 = 'c2_75_25',
  C3_20_40_40 = 'c3_20_40_40',
  C3_25_25_50 = 'c3_25_25_50',
  C3_25_50_25 = 'c3_25_50_25',
  C3_30_30_40 = 'c3_30_30_40',
  C3_30_40_30 = 'c3_30_40_30',
  C3_33_33_34 = 'c3_33_33_34',
  C3_40_30_30 = 'c3_40_30_30',
  C3_50_25_25 = 'c3_50_25_25',
  C4_15_15_30_40 = 'c4_15_15_30_40',
  C4_15_15_35_35 = 'c4_15_15_35_35',
  C4_20_20_20_40 = 'c4_20_20_20_40',
  C4_20_20_40_20 = 'c4_20_20_40_20',
  C4_20_40_20_20 = 'c4_20_40_20_20',
  C4_25_25_25_25 = 'c4_25_25_25_25',
  C4_35_35_15_15 = 'c4_35_35_15_15',
  C4_40_20_20_20 = 'c4_40_20_20_20',
  C4_40_30_15_15 = 'c4_40_30_15_15',
  C5_10_15_15_20_40 = 'c5_10_15_15_20_40',
  C5_15_15_15_20_35 = 'c5_15_15_15_20_35',
  C5_17_17_30_18_18 = 'c5_17_17_30_18_18',
  C5_17_18_18_17_30 = 'c5_17_18_18_17_30',
  C5_17_30_18_18_17 = 'c5_17_30_18_18_17',
  C5_18_17_17_30_18 = 'c5_18_17_17_30_18',
  C5_20_20_20_20_20 = 'c5_20_20_20_20_20',
  C5_30_18_18_17_17 = 'c5_30_18_18_17_17',
  C5_35_20_15_15_15 = 'c5_35_20_15_15_15',
  C5_40_20_15_15_10 = 'c5_40_20_15_15_10',
}

export enum Enum_Componentblockstablewidget_Tableinnerbackgroundcolor {
  BrandDark = 'brand_dark',
  Gradient_1 = 'gradient_1',
  Gradient_2 = 'gradient_2',
  Gradient_3 = 'gradient_3',
  Gradient_4 = 'gradient_4',
  GradientCta = 'gradient_cta',
  GradientPrimaryDark = 'gradient_primary_dark',
  GradientPurpleDark = 'gradient_purple_dark',
  GradientSecondaryBrand = 'gradient_secondary_brand',
  None = 'none',
  OrbCover = 'orb_cover',
  Primary = 'primary',
  PrimaryDark = 'primary_dark',
  Purple_100 = 'purple_100',
  Purple_200 = 'purple_200',
  Purple_400 = 'purple_400',
  Purple_500 = 'purple_500',
  Purple_800 = 'purple_800',
  Purple_900 = 'purple_900',
  Secondary = 'secondary',
}

export enum Enum_Componentblocksthreecolumntext_Centerbodyfontsize {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xs = 'xs',
}

export enum Enum_Componentblocksthreecolumntext_Centerheadingfontsize {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
}

export enum Enum_Componentblocksthreecolumntext_Leftbodyfontsize {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xs = 'xs',
}

export enum Enum_Componentblocksthreecolumntext_Leftheadingfontsize {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
}

export enum Enum_Componentblocksthreecolumntext_Rightbodyfontsize {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xs = 'xs',
}

export enum Enum_Componentblocksthreecolumntext_Rightheadingfontsize {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
}

export enum Enum_Componentblocksthreecolumntext_Threecolumnvariant {
  Card = 'card',
  Plain = 'plain',
}

export enum Enum_Componentblockstwocolumntextimageblock_Imagealignment {
  Center = 'Center',
  Top = 'Top',
}

export enum Enum_Componentblockstwocolumntextimageblock_Imagecolumnsize {
  Percent25 = 'percent25',
  Percent30 = 'percent30',
  Percent33 = 'percent33',
  Percent35 = 'percent35',
  Percent40 = 'percent40',
  Percent45 = 'percent45',
  Percent50 = 'percent50',
}

export enum Enum_Componentblockstwocolumntextimageblock_Itemspacing {
  Around = 'around',
  Between = 'between',
}

export enum Enum_Componentblockstwocolumntextimageblock_Textcolumnsize {
  Auto = 'auto',
  Percent25 = 'percent25',
  Percent30 = 'percent30',
  Percent33 = 'percent33',
  Percent35 = 'percent35',
  Percent40 = 'percent40',
  Percent45 = 'percent45',
  Percent50 = 'percent50',
  Percent55 = 'percent55',
  Percent60 = 'percent60',
  Percent65 = 'percent65',
  Percent70 = 'percent70',
  Percent75 = 'percent75',
}

export enum Enum_Componentloanloancomparison_Defaultproducttype {
  AssetFinance = 'Asset_Finance',
  Bridging = 'Bridging',
  BridgingLoan = 'Bridging_Loan',
  CapitalisedInterest = 'Capitalised_Interest',
  ChattelMortgage = 'Chattel_Mortgage',
  CombinationMultiple = 'Combination_Multiple',
  ConsumerAsset = 'Consumer_Asset',
  ConsumerPersonalLoan = 'Consumer_Personal_Loan',
  DevelopmentAndConstructionFunding = 'Development_and_Construction_Funding',
  FinanceLeaseRental = 'Finance_Lease_Rental',
  HirePurchase = 'Hire_Purchase',
  HomeLoan = 'Home_Loan',
  InterestOnly = 'Interest_Only',
  InvoiceFinance = 'Invoice_Finance',
  LineOfCredit = 'Line_of_Credit',
  MerchantCashAdvance = 'Merchant_Cash_Advance',
  OperatingLease = 'Operating_Lease',
  OtherNotSure = 'Other_Not_Sure',
  OverdraftFacility = 'Overdraft_Facility',
  PrivateLending = 'Private_Lending',
  Smsf = 'SMSF',
  SecuredLoan = 'Secured_Loan',
  TermLoan = 'Term_Loan',
  TradeFinance = 'Trade_Finance',
  UnsecuredLoan = 'Unsecured_Loan',
}

export enum Enum_Componentloanloancomparison_Defaultpurpose {
  DayToDayCapital = 'Day_to_day_Capital',
  DevelopmentAndConstruction = 'Development_and_Construction',
  Expansion = 'Expansion',
  MachineryOrEquipment = 'Machinery_or_Equipment',
  NewFitOut = 'New_Fit_out',
  Other = 'Other',
  PayDomesticOrInternationalSuppliers = 'Pay_Domestic_or_International_Suppliers',
  Property = 'Property',
  PurchaseExistingBusiness = 'Purchase_Existing_Business',
  Renovation = 'Renovation',
  StaffRecruitmentCosts = 'Staff_Recruitment_Costs',
  StartANewBusiness = 'Start_a_New_Business',
  VehiclesOrTransport = 'Vehicles_or_Transport',
  WaitingForInvoicesToBePaid = 'Waiting_for_Invoices_to_be_Paid',
}

export enum Enum_Componentloanloancomparison_Defaultsort {
  AmountHighToLow = 'amountHighToLow',
  InterestLowToHigh = 'interestLowToHigh',
  ProviderAz = 'providerAZ',
  ProviderZa = 'providerZA',
}

export enum Enum_Componentloanloancomparison_Defaultview {
  Grid = 'grid',
  List = 'list',
}

export enum Enum_Componentloanloanhighlight_Highlightdefaultproducttype {
  AssetFinance = 'Asset_Finance',
  Bridging = 'Bridging',
  BridgingLoan = 'Bridging_Loan',
  CapitalisedInterest = 'Capitalised_Interest',
  ChattelMortgage = 'Chattel_Mortgage',
  CombinationMultiple = 'Combination_Multiple',
  ConsumerAsset = 'Consumer_Asset',
  ConsumerPersonalLoan = 'Consumer_Personal_Loan',
  DevelopmentAndConstructionFunding = 'Development_and_Construction_Funding',
  FinanceLeaseRental = 'Finance_Lease_Rental',
  HirePurchase = 'Hire_Purchase',
  HomeLoan = 'Home_Loan',
  InterestOnly = 'Interest_Only',
  InvoiceFinance = 'Invoice_Finance',
  LineOfCredit = 'Line_of_Credit',
  MerchantCashAdvance = 'Merchant_Cash_Advance',
  OperatingLease = 'Operating_Lease',
  OtherNotSure = 'Other_Not_Sure',
  OverdraftFacility = 'Overdraft_Facility',
  PrivateLending = 'Private_Lending',
  Smsf = 'SMSF',
  SecuredLoan = 'Secured_Loan',
  TermLoan = 'Term_Loan',
  TradeFinance = 'Trade_Finance',
  UnsecuredLoan = 'Unsecured_Loan',
}

export enum Enum_Componentloanloanhighlight_Highlightdefaultpurpose {
  DayToDayCapital = 'Day_to_day_Capital',
  DevelopmentAndConstruction = 'Development_and_Construction',
  Expansion = 'Expansion',
  MachineryOrEquipment = 'Machinery_or_Equipment',
  NewFitOut = 'New_Fit_out',
  Other = 'Other',
  PayDomesticOrInternationalSuppliers = 'Pay_Domestic_or_International_Suppliers',
  Property = 'Property',
  PurchaseExistingBusiness = 'Purchase_Existing_Business',
  Renovation = 'Renovation',
  StaffRecruitmentCosts = 'Staff_Recruitment_Costs',
  StartANewBusiness = 'Start_a_New_Business',
  VehiclesOrTransport = 'Vehicles_or_Transport',
  WaitingForInvoicesToBePaid = 'Waiting_for_Invoices_to_be_Paid',
}

export enum Enum_Componentsharedbackground_Backgroundcolor {
  BrandDark = 'brand_dark',
  Gradient_1 = 'gradient_1',
  Gradient_2 = 'gradient_2',
  Gradient_3 = 'gradient_3',
  Gradient_4 = 'gradient_4',
  GradientCta = 'gradient_cta',
  GradientPrimaryDark = 'gradient_primary_dark',
  GradientPurpleDark = 'gradient_purple_dark',
  GradientSecondaryBrand = 'gradient_secondary_brand',
  None = 'none',
  OrbCover = 'orb_cover',
  Primary = 'primary',
  PrimaryDark = 'primary_dark',
  Purple_100 = 'purple_100',
  Purple_200 = 'purple_200',
  Purple_400 = 'purple_400',
  Purple_500 = 'purple_500',
  Purple_800 = 'purple_800',
  Purple_900 = 'purple_900',
  Secondary = 'secondary',
}

export enum Enum_Componentsharedbackground_Backgroundorbs {
  BrandDark_1Bottom = 'brandDark_1_bottom',
  BrandDark_1Center = 'brandDark_1_center',
  BrandDark_1Left = 'brandDark_1_left',
  BrandDark_1Right = 'brandDark_1_right',
  BrandDark_1Top = 'brandDark_1_top',
  BrandDark_3Left = 'brandDark_3_left',
  BrandDark_3Right = 'brandDark_3_right',
  BrandDark_5Left = 'brandDark_5_left',
  BrandDark_5Right = 'brandDark_5_right',
  Brand_1Bottom = 'brand_1_bottom',
  Brand_1Center = 'brand_1_center',
  Brand_1Left = 'brand_1_left',
  Brand_1Right = 'brand_1_right',
  Brand_1Top = 'brand_1_top',
  Brand_3Left = 'brand_3_left',
  Brand_3Right = 'brand_3_right',
  Brand_5Left = 'brand_5_left',
  Brand_5Right = 'brand_5_right',
  Mixed_3Left = 'mixed_3_left',
  Mixed_3Right = 'mixed_3_right',
  Mixed_5Left = 'mixed_5_left',
  Mixed_5Right = 'mixed_5_right',
  Mixed_7Left = 'mixed_7_left',
  Mixed_7Right = 'mixed_7_right',
  Mixed_9Left = 'mixed_9_left',
  Mixed_9Right = 'mixed_9_right',
  Multi_1Bottom = 'multi_1_bottom',
  Multi_1Center = 'multi_1_center',
  Multi_1Left = 'multi_1_left',
  Multi_1Right = 'multi_1_right',
  Multi_1Top = 'multi_1_top',
  Multi_2Left = 'multi_2_left',
  Multi_2Right = 'multi_2_right',
  Multi_3Left = 'multi_3_left',
  Multi_3Right = 'multi_3_right',
  Multi_5Left = 'multi_5_left',
  Multi_5Right = 'multi_5_right',
  None = 'none',
  Primary_1Bottom = 'primary_1_bottom',
  Primary_1Center = 'primary_1_center',
  Primary_1Left = 'primary_1_left',
  Primary_1Right = 'primary_1_right',
  Primary_1Top = 'primary_1_top',
  Primary_3Left = 'primary_3_left',
  Primary_3Right = 'primary_3_right',
  Primary_5Left = 'primary_5_left',
  Primary_5Right = 'primary_5_right',
  Purple500_1Bottom = 'purple500_1_bottom',
  Purple500_1Center = 'purple500_1_center',
  Purple500_1Left = 'purple500_1_left',
  Purple500_1Right = 'purple500_1_right',
  Purple500_1Top = 'purple500_1_top',
  Purple500_3Left = 'purple500_3_left',
  Purple500_3Right = 'purple500_3_right',
  Purple500_5Left = 'purple500_5_left',
  Purple500_5Right = 'purple500_5_right',
  Purple600_1Bottom = 'purple600_1_bottom',
  Purple600_1Center = 'purple600_1_center',
  Purple600_1Left = 'purple600_1_left',
  Purple600_1Right = 'purple600_1_right',
  Purple600_1Top = 'purple600_1_top',
  Purple600_3Left = 'purple600_3_left',
  Purple600_3Right = 'purple600_3_right',
  Purple600_5Left = 'purple600_5_left',
  Purple600_5Right = 'purple600_5_right',
  Purple800_1Bottom = 'purple800_1_bottom',
  Purple800_1Center = 'purple800_1_center',
  Purple800_1Left = 'purple800_1_left',
  Purple800_1Right = 'purple800_1_right',
  Purple800_1Top = 'purple800_1_top',
  Purple800_3Left = 'purple800_3_left',
  Purple800_3Right = 'purple800_3_right',
  Purple800_5Left = 'purple800_5_left',
  Purple800_5Right = 'purple800_5_right',
  Purple900_1Bottom = 'purple900_1_bottom',
  Purple900_1Center = 'purple900_1_center',
  Purple900_1Left = 'purple900_1_left',
  Purple900_1Right = 'purple900_1_right',
  Purple900_1Top = 'purple900_1_top',
  Purple900_3Left = 'purple900_3_left',
  Purple900_3Right = 'purple900_3_right',
  Purple900_5Left = 'purple900_5_left',
  Purple900_5Right = 'purple900_5_right',
  Secondary_1Bottom = 'secondary_1_bottom',
  Secondary_1Center = 'secondary_1_center',
  Secondary_1Left = 'secondary_1_left',
  Secondary_1Right = 'secondary_1_right',
  Secondary_1Top = 'secondary_1_top',
  Secondary_3Left = 'secondary_3_left',
  Secondary_3Right = 'secondary_3_right',
  Secondary_5Left = 'secondary_5_left',
  Secondary_5Right = 'secondary_5_right',
  White_1Bottom = 'white_1_bottom',
  White_1Center = 'white_1_center',
  White_1Left = 'white_1_left',
  White_1Right = 'white_1_right',
  White_1Top = 'white_1_top',
  White_3Left = 'white_3_left',
  White_3Right = 'white_3_right',
  White_5Left = 'white_5_left',
  White_5Right = 'white_5_right',
}

export enum Enum_Componentshareddisplayoptions_Contentswidth {
  ExtraWide = 'extra_wide',
  Narrow = 'narrow',
  Standard = 'standard',
  Wide = 'wide',
}

export enum Enum_Componentshareddisplayoptions_Paddingbottom {
  Lg = 'lg',
  Md = 'md',
  None = 'none',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
}

export enum Enum_Componentshareddisplayoptions_Paddinginline {
  Lg = 'lg',
  Md = 'md',
  None = 'none',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
}

export enum Enum_Componentshareddisplayoptions_Paddingtop {
  Lg = 'lg',
  Md = 'md',
  None = 'none',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
}

export enum Enum_Componentsharedsitebanner_Bannertype {
  Brand = 'Brand',
  Primary = 'Primary',
  Secondary = 'Secondary',
  Warning = 'Warning',
}

export enum Enum_Componentsharedsociallink_Platform {
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  LinkedIn = 'LinkedIn',
  TikTok = 'TikTok',
  Twitter = 'Twitter',
  YouTube = 'YouTube',
}

export enum Enum_Loancalculator_Calculatortype {
  Amortisation = 'Amortisation',
  BorrowingPower = 'BorrowingPower',
  BusinessLoan = 'BusinessLoan',
  BusinessOverdraft = 'BusinessOverdraft',
  CarDepreciation = 'CarDepreciation',
  CarLoan = 'CarLoan',
  ChattelMortgage = 'ChattelMortgage',
  CommercialPropertyLoan = 'CommercialPropertyLoan',
  ConstructionLoan = 'ConstructionLoan',
  EarlyRepayment = 'EarlyRepayment',
  EquipmentFinance = 'EquipmentFinance',
  FactorToApr = 'FactorToApr',
  FinanceLease = 'FinanceLease',
  GuarantorLoan = 'GuarantorLoan',
  HirePurchase = 'HirePurchase',
  LeaseVsLoan = 'LeaseVsLoan',
  LineOfCredit = 'LineOfCredit',
  LoanRepayment = 'LoanRepayment',
  PayslipEstimator = 'PayslipEstimator',
}

export enum Enum_Review_Reviewtype {
  Broker = 'broker',
  Customer = 'customer',
}

export enum Enum_Synclog_Syncstatus {
  Failed = 'failed',
  Started = 'started',
  Success = 'success',
}

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialCalculator = {
  __typename?: 'FinancialCalculator';
  category?: Maybe<CalculatorCategory>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  documentId: Scalars['ID']['output'];
  formula: Scalars['String']['output'];
  input_fields: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  output_field?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FinancialCalculatorEntityResponseCollection = {
  __typename?: 'FinancialCalculatorEntityResponseCollection';
  nodes: Array<FinancialCalculator>;
  pageInfo: Pagination;
};

export type FinancialCalculatorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FinancialCalculatorFiltersInput>>>;
  category?: InputMaybe<CalculatorCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  display_order?: InputMaybe<IntFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  formula?: InputMaybe<StringFilterInput>;
  input_fields?: InputMaybe<JsonFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<FinancialCalculatorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<FinancialCalculatorFiltersInput>>>;
  output_field?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type FinancialCalculatorInput = {
  category?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  formula?: InputMaybe<Scalars['String']['input']>;
  input_fields?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  output_field?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialCalculatorRelationResponseCollection = {
  __typename?: 'FinancialCalculatorRelationResponseCollection';
  nodes: Array<FinancialCalculator>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type GenericMorph =
  | About
  | CalculatorCategory
  | ComponentBlocksActionBlock
  | ComponentBlocksAdditionalFeatures
  | ComponentBlocksAuthorDetails
  | ComponentBlocksBottomPageMetric
  | ComponentBlocksBreak
  | ComponentBlocksButton
  | ComponentBlocksCalculatorGrid
  | ComponentBlocksConList
  | ComponentBlocksConTableList
  | ComponentBlocksCta
  | ComponentBlocksFaqList
  | ComponentBlocksFeature
  | ComponentBlocksFunnel
  | ComponentBlocksHeroForm
  | ComponentBlocksHeroSimple
  | ComponentBlocksHighlightBlock
  | ComponentBlocksHomepageHeroForm
  | ComponentBlocksHtml
  | ComponentBlocksImage
  | ComponentBlocksInfoTile
  | ComponentBlocksInfoTilesBlock
  | ComponentBlocksInfoTilesRow
  | ComponentBlocksLandingPageHero
  | ComponentBlocksLatestResourcesBlock
  | ComponentBlocksLenderList
  | ComponentBlocksLoanCalculators
  | ComponentBlocksLogosBlock
  | ComponentBlocksMetricHighlight
  | ComponentBlocksMetricHighlightInfo
  | ComponentBlocksPageSeparator
  | ComponentBlocksPlatformReviewsBlock
  | ComponentBlocksPostcard
  | ComponentBlocksProList
  | ComponentBlocksProTableList
  | ComponentBlocksProductFeatures
  | ComponentBlocksProductFeaturesTabs
  | ComponentBlocksProsAndConsTable
  | ComponentBlocksProsAndConsTableV2
  | ComponentBlocksQuestionList
  | ComponentBlocksRelatedArticles
  | ComponentBlocksRelatedBlogs
  | ComponentBlocksStepItem
  | ComponentBlocksStepsList
  | ComponentBlocksTable
  | ComponentBlocksTableCellItem
  | ComponentBlocksTableHeadingItem
  | ComponentBlocksTableRowItem
  | ComponentBlocksTableWidget
  | ComponentBlocksTeam
  | ComponentBlocksText
  | ComponentBlocksThreeColumnText
  | ComponentBlocksThreeSteps
  | ComponentBlocksTimeline
  | ComponentBlocksTwoColumnTextImageBlock
  | ComponentCalculatorCalculatorHighlight
  | ComponentDataHomepageContent
  | ComponentDataHomepageMadeEasyCard
  | ComponentDataHomepageProfileRow
  | ComponentDataHomepageStep
  | ComponentDataOfficeLocation
  | ComponentLoanLoanComparison
  | ComponentLoanLoanHighlight
  | ComponentMenuMainMenuSettings
  | ComponentMenuMenuLinkPage
  | ComponentMenuMenuLinkResource
  | ComponentMenuMenuLinkResourceCategory
  | ComponentMenuMenuLinkUrl
  | ComponentMenuMenuSubMenu
  | ComponentRepeatableProsAndConsRow
  | ComponentSharedArticleExplainer
  | ComponentSharedArticleExplainerItem
  | ComponentSharedArticleSidebarCta
  | ComponentSharedArticleSidebarCtaItem
  | ComponentSharedAward
  | ComponentSharedBackground
  | ComponentSharedDisplayOptions
  | ComponentSharedFooterLogo
  | ComponentSharedOpenGraph
  | ComponentSharedSeo
  | ComponentSharedSideBarContent
  | ComponentSharedSiteBanner
  | ComponentSharedSocialLink
  | Contact
  | FinancialCalculator
  | Homepage
  | I18NLocale
  | LandingPage
  | Lender
  | LenderTier
  | LoanCalculator
  | Menu
  | Page
  | PageCategory
  | ResourceArticle
  | ResourceCategory
  | ResourceCenter
  | Review
  | ReviewWorkflowsWorkflow
  | ReviewWorkflowsWorkflowStage
  | SiteSetting
  | SyncLog
  | TeamMember
  | UploadFile
  | UsersPermissionsPermission
  | UsersPermissionsRole
  | UsersPermissionsUser;

export type Homepage = {
  __typename?: 'Homepage';
  CustomContent?: Maybe<ComponentDataHomepageContent>;
  HomepageBlocks?: Maybe<Array<Maybe<HomepageHomepageBlocksDynamicZone>>>;
  PageHero?: Maybe<ComponentBlocksHomepageHeroForm>;
  ShowStaticCTA?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HomepageHomepageBlocksDynamicZone =
  | ComponentBlocksActionBlock
  | ComponentBlocksAdditionalFeatures
  | ComponentBlocksAuthorDetails
  | ComponentBlocksBreak
  | ComponentBlocksCalculatorGrid
  | ComponentBlocksCta
  | ComponentBlocksFaqList
  | ComponentBlocksFunnel
  | ComponentBlocksHighlightBlock
  | ComponentBlocksHtml
  | ComponentBlocksImage
  | ComponentBlocksInfoTilesBlock
  | ComponentBlocksLatestResourcesBlock
  | ComponentBlocksLenderList
  | ComponentBlocksLoanCalculators
  | ComponentBlocksMetricHighlight
  | ComponentBlocksPageSeparator
  | ComponentBlocksPlatformReviewsBlock
  | ComponentBlocksPostcard
  | ComponentBlocksProductFeatures
  | ComponentBlocksProsAndConsTable
  | ComponentBlocksProsAndConsTableV2
  | ComponentBlocksRelatedArticles
  | ComponentBlocksRelatedBlogs
  | ComponentBlocksStepsList
  | ComponentBlocksTableWidget
  | ComponentBlocksText
  | ComponentBlocksThreeColumnText
  | ComponentBlocksThreeSteps
  | ComponentBlocksTwoColumnTextImageBlock
  | ComponentCalculatorCalculatorHighlight
  | ComponentLoanLoanComparison
  | ComponentLoanLoanHighlight
  | Error;

export type HomepageInput = {
  CustomContent?: InputMaybe<ComponentDataHomepageContentInput>;
  HomepageBlocks?: InputMaybe<Array<Scalars['HomepageHomepageBlocksDynamicZoneInput']['input']>>;
  PageHero?: InputMaybe<ComponentBlocksHomepageHeroFormInput>;
  ShowStaticCTA?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  nodes: Array<I18NLocale>;
  pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type LandingPage = {
  __typename?: 'LandingPage';
  LandingPageBlocks?: Maybe<Array<Maybe<LandingPageLandingPageBlocksDynamicZone>>>;
  LandingPageHero: ComponentBlocksLandingPageHero;
  LandingPageSeo?: Maybe<Array<Maybe<ComponentSharedSeo>>>;
  NoIndex?: Maybe<Scalars['Boolean']['output']>;
  PageCategory?: Maybe<PageCategory>;
  Title?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LandingPageLandingPageSeoArgs = {
  filters?: InputMaybe<ComponentSharedSeoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LandingPageEntityResponseCollection = {
  __typename?: 'LandingPageEntityResponseCollection';
  nodes: Array<LandingPage>;
  pageInfo: Pagination;
};

export type LandingPageFiltersInput = {
  LandingPageHero?: InputMaybe<ComponentBlocksLandingPageHeroFiltersInput>;
  LandingPageSeo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  NoIndex?: InputMaybe<BooleanFilterInput>;
  PageCategory?: InputMaybe<PageCategoryFiltersInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<LandingPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<LandingPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LandingPageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LandingPageInput = {
  LandingPageBlocks?: InputMaybe<
    Array<Scalars['LandingPageLandingPageBlocksDynamicZoneInput']['input']>
  >;
  LandingPageHero?: InputMaybe<ComponentBlocksLandingPageHeroInput>;
  LandingPageSeo?: InputMaybe<Array<InputMaybe<ComponentSharedSeoInput>>>;
  NoIndex?: InputMaybe<Scalars['Boolean']['input']>;
  PageCategory?: InputMaybe<Scalars['ID']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LandingPageLandingPageBlocksDynamicZone =
  | ComponentBlocksActionBlock
  | ComponentBlocksAdditionalFeatures
  | ComponentBlocksAuthorDetails
  | ComponentBlocksBreak
  | ComponentBlocksCalculatorGrid
  | ComponentBlocksCta
  | ComponentBlocksFaqList
  | ComponentBlocksFunnel
  | ComponentBlocksHighlightBlock
  | ComponentBlocksHtml
  | ComponentBlocksImage
  | ComponentBlocksInfoTilesBlock
  | ComponentBlocksLatestResourcesBlock
  | ComponentBlocksLenderList
  | ComponentBlocksLoanCalculators
  | ComponentBlocksMetricHighlight
  | ComponentBlocksPageSeparator
  | ComponentBlocksPlatformReviewsBlock
  | ComponentBlocksPostcard
  | ComponentBlocksProductFeatures
  | ComponentBlocksProsAndConsTable
  | ComponentBlocksProsAndConsTableV2
  | ComponentBlocksRelatedArticles
  | ComponentBlocksRelatedBlogs
  | ComponentBlocksStepsList
  | ComponentBlocksTableWidget
  | ComponentBlocksText
  | ComponentBlocksThreeColumnText
  | ComponentBlocksThreeSteps
  | ComponentBlocksTwoColumnTextImageBlock
  | ComponentCalculatorCalculatorHighlight
  | ComponentLoanLoanComparison
  | ComponentLoanLoanHighlight
  | Error;

export type Lender = {
  __typename?: 'Lender';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hideApr?: Maybe<Scalars['Boolean']['output']>;
  lenderLogo?: Maybe<Scalars['String']['output']>;
  lenderName?: Maybe<Scalars['String']['output']>;
  lenderRef: Scalars['String']['output'];
  lenderTiers: Array<Maybe<LenderTier>>;
  lenderTiers_connection?: Maybe<LenderTierRelationResponseCollection>;
  maxApr?: Maybe<Scalars['Float']['output']>;
  maxLoanAmount?: Maybe<Scalars['Float']['output']>;
  maxLoanTerm?: Maybe<Scalars['Int']['output']>;
  maxMonthlySales?: Maybe<Scalars['Float']['output']>;
  maxTimeInBiz?: Maybe<Scalars['Int']['output']>;
  minApr?: Maybe<Scalars['Float']['output']>;
  minLoanAmount?: Maybe<Scalars['Float']['output']>;
  minLoanTerm?: Maybe<Scalars['Int']['output']>;
  minMonthlySales?: Maybe<Scalars['Float']['output']>;
  minTimeInBiz?: Maybe<Scalars['Int']['output']>;
  overrideApr?: Maybe<Scalars['Boolean']['output']>;
  overrideMaxApr?: Maybe<Scalars['Float']['output']>;
  overrideMinApr?: Maybe<Scalars['Float']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  purposeAllowed?: Maybe<Scalars['JSON']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LenderLenderTiersArgs = {
  filters?: InputMaybe<LenderTierFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LenderLenderTiers_ConnectionArgs = {
  filters?: InputMaybe<LenderTierFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LenderEntityResponseCollection = {
  __typename?: 'LenderEntityResponseCollection';
  nodes: Array<Lender>;
  pageInfo: Pagination;
};

export type LenderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LenderFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  hideApr?: InputMaybe<BooleanFilterInput>;
  lenderLogo?: InputMaybe<StringFilterInput>;
  lenderName?: InputMaybe<StringFilterInput>;
  lenderRef?: InputMaybe<StringFilterInput>;
  lenderTiers?: InputMaybe<LenderTierFiltersInput>;
  maxApr?: InputMaybe<FloatFilterInput>;
  maxLoanAmount?: InputMaybe<FloatFilterInput>;
  maxLoanTerm?: InputMaybe<IntFilterInput>;
  maxMonthlySales?: InputMaybe<FloatFilterInput>;
  maxTimeInBiz?: InputMaybe<IntFilterInput>;
  minApr?: InputMaybe<FloatFilterInput>;
  minLoanAmount?: InputMaybe<FloatFilterInput>;
  minLoanTerm?: InputMaybe<IntFilterInput>;
  minMonthlySales?: InputMaybe<FloatFilterInput>;
  minTimeInBiz?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<LenderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LenderFiltersInput>>>;
  overrideApr?: InputMaybe<BooleanFilterInput>;
  overrideMaxApr?: InputMaybe<FloatFilterInput>;
  overrideMinApr?: InputMaybe<FloatFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  purposeAllowed?: InputMaybe<JsonFilterInput>;
  updated?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LenderInput = {
  hideApr?: InputMaybe<Scalars['Boolean']['input']>;
  lenderLogo?: InputMaybe<Scalars['String']['input']>;
  lenderName?: InputMaybe<Scalars['String']['input']>;
  lenderRef?: InputMaybe<Scalars['String']['input']>;
  lenderTiers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  maxApr?: InputMaybe<Scalars['Float']['input']>;
  maxLoanAmount?: InputMaybe<Scalars['Float']['input']>;
  maxLoanTerm?: InputMaybe<Scalars['Int']['input']>;
  maxMonthlySales?: InputMaybe<Scalars['Float']['input']>;
  maxTimeInBiz?: InputMaybe<Scalars['Int']['input']>;
  minApr?: InputMaybe<Scalars['Float']['input']>;
  minLoanAmount?: InputMaybe<Scalars['Float']['input']>;
  minLoanTerm?: InputMaybe<Scalars['Int']['input']>;
  minMonthlySales?: InputMaybe<Scalars['Float']['input']>;
  minTimeInBiz?: InputMaybe<Scalars['Int']['input']>;
  overrideApr?: InputMaybe<Scalars['Boolean']['input']>;
  overrideMaxApr?: InputMaybe<Scalars['Float']['input']>;
  overrideMinApr?: InputMaybe<Scalars['Float']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  purposeAllowed?: InputMaybe<Scalars['JSON']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LenderRelationResponseCollection = {
  __typename?: 'LenderRelationResponseCollection';
  nodes: Array<Lender>;
};

export type LenderTier = {
  __typename?: 'LenderTier';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hideApr?: Maybe<Scalars['Boolean']['output']>;
  lender?: Maybe<Lender>;
  maxApr?: Maybe<Scalars['Float']['output']>;
  maxLoanAmount?: Maybe<Scalars['Float']['output']>;
  maxLoanTerm?: Maybe<Scalars['Int']['output']>;
  maxMonthlySales?: Maybe<Scalars['Float']['output']>;
  maxTimeInBiz?: Maybe<Scalars['Int']['output']>;
  minApr?: Maybe<Scalars['Float']['output']>;
  minLoanAmount?: Maybe<Scalars['Float']['output']>;
  minLoanTerm?: Maybe<Scalars['Int']['output']>;
  minMonthlySales?: Maybe<Scalars['Float']['output']>;
  minTimeInBiz?: Maybe<Scalars['Int']['output']>;
  overrideApr?: Maybe<Scalars['Boolean']['output']>;
  overrideMaxApr?: Maybe<Scalars['Float']['output']>;
  overrideMinApr?: Maybe<Scalars['Float']['output']>;
  productTypesAllowed?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  purposeAllowed?: Maybe<Scalars['JSON']['output']>;
  tierDisplayName?: Maybe<Scalars['String']['output']>;
  tierName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LenderTierEntityResponseCollection = {
  __typename?: 'LenderTierEntityResponseCollection';
  nodes: Array<LenderTier>;
  pageInfo: Pagination;
};

export type LenderTierFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LenderTierFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  hideApr?: InputMaybe<BooleanFilterInput>;
  lender?: InputMaybe<LenderFiltersInput>;
  maxApr?: InputMaybe<FloatFilterInput>;
  maxLoanAmount?: InputMaybe<FloatFilterInput>;
  maxLoanTerm?: InputMaybe<IntFilterInput>;
  maxMonthlySales?: InputMaybe<FloatFilterInput>;
  maxTimeInBiz?: InputMaybe<IntFilterInput>;
  minApr?: InputMaybe<FloatFilterInput>;
  minLoanAmount?: InputMaybe<FloatFilterInput>;
  minLoanTerm?: InputMaybe<IntFilterInput>;
  minMonthlySales?: InputMaybe<FloatFilterInput>;
  minTimeInBiz?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<LenderTierFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LenderTierFiltersInput>>>;
  overrideApr?: InputMaybe<BooleanFilterInput>;
  overrideMaxApr?: InputMaybe<FloatFilterInput>;
  overrideMinApr?: InputMaybe<FloatFilterInput>;
  productTypesAllowed?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  purposeAllowed?: InputMaybe<JsonFilterInput>;
  tierDisplayName?: InputMaybe<StringFilterInput>;
  tierName?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LenderTierInput = {
  hideApr?: InputMaybe<Scalars['Boolean']['input']>;
  lender?: InputMaybe<Scalars['ID']['input']>;
  maxApr?: InputMaybe<Scalars['Float']['input']>;
  maxLoanAmount?: InputMaybe<Scalars['Float']['input']>;
  maxLoanTerm?: InputMaybe<Scalars['Int']['input']>;
  maxMonthlySales?: InputMaybe<Scalars['Float']['input']>;
  maxTimeInBiz?: InputMaybe<Scalars['Int']['input']>;
  minApr?: InputMaybe<Scalars['Float']['input']>;
  minLoanAmount?: InputMaybe<Scalars['Float']['input']>;
  minLoanTerm?: InputMaybe<Scalars['Int']['input']>;
  minMonthlySales?: InputMaybe<Scalars['Float']['input']>;
  minTimeInBiz?: InputMaybe<Scalars['Int']['input']>;
  overrideApr?: InputMaybe<Scalars['Boolean']['input']>;
  overrideMaxApr?: InputMaybe<Scalars['Float']['input']>;
  overrideMinApr?: InputMaybe<Scalars['Float']['input']>;
  productTypesAllowed?: InputMaybe<Scalars['JSON']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  purposeAllowed?: InputMaybe<Scalars['JSON']['input']>;
  tierDisplayName?: InputMaybe<Scalars['String']['input']>;
  tierName?: InputMaybe<Scalars['String']['input']>;
};

export type LenderTierRelationResponseCollection = {
  __typename?: 'LenderTierRelationResponseCollection';
  nodes: Array<LenderTier>;
};

export type LoanCalculator = {
  __typename?: 'LoanCalculator';
  CalculatorCategory?: Maybe<CalculatorCategory>;
  CalculatorDescription?: Maybe<Scalars['JSON']['output']>;
  CalculatorPage?: Maybe<Page>;
  CalculatorTitle: Scalars['String']['output'];
  CalculatorType?: Maybe<Enum_Loancalculator_Calculatortype>;
  CustomCalculatorCTA?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LoanCalculatorEntityResponseCollection = {
  __typename?: 'LoanCalculatorEntityResponseCollection';
  nodes: Array<LoanCalculator>;
  pageInfo: Pagination;
};

export type LoanCalculatorFiltersInput = {
  CalculatorCategory?: InputMaybe<CalculatorCategoryFiltersInput>;
  CalculatorDescription?: InputMaybe<JsonFilterInput>;
  CalculatorPage?: InputMaybe<PageFiltersInput>;
  CalculatorTitle?: InputMaybe<StringFilterInput>;
  CalculatorType?: InputMaybe<StringFilterInput>;
  CustomCalculatorCTA?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<LoanCalculatorFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<LoanCalculatorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LoanCalculatorFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LoanCalculatorInput = {
  CalculatorCategory?: InputMaybe<Scalars['ID']['input']>;
  CalculatorDescription?: InputMaybe<Scalars['JSON']['input']>;
  CalculatorPage?: InputMaybe<Scalars['ID']['input']>;
  CalculatorTitle?: InputMaybe<Scalars['String']['input']>;
  CalculatorType?: InputMaybe<Enum_Loancalculator_Calculatortype>;
  CustomCalculatorCTA?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LoanCalculatorRelationResponseCollection = {
  __typename?: 'LoanCalculatorRelationResponseCollection';
  nodes: Array<LoanCalculator>;
};

export type Menu = {
  __typename?: 'Menu';
  IsRootMenu?: Maybe<Scalars['Boolean']['output']>;
  MenuItems?: Maybe<Array<Maybe<MenuMenuItemsDynamicZone>>>;
  MenuKey: Scalars['String']['output'];
  MenuName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MenuEntityResponseCollection = {
  __typename?: 'MenuEntityResponseCollection';
  nodes: Array<Menu>;
  pageInfo: Pagination;
};

export type MenuFiltersInput = {
  IsRootMenu?: InputMaybe<BooleanFilterInput>;
  MenuKey?: InputMaybe<StringFilterInput>;
  MenuName?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<MenuFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<MenuFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MenuFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MenuInput = {
  IsRootMenu?: InputMaybe<Scalars['Boolean']['input']>;
  MenuItems?: InputMaybe<Array<Scalars['MenuMenuItemsDynamicZoneInput']['input']>>;
  MenuKey?: InputMaybe<Scalars['String']['input']>;
  MenuName?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MenuMenuItemsDynamicZone =
  | ComponentMenuMenuLinkPage
  | ComponentMenuMenuLinkResource
  | ComponentMenuMenuLinkResourceCategory
  | ComponentMenuMenuLinkUrl
  | ComponentMenuMenuSubMenu
  | Error;

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createCalculatorCategory?: Maybe<CalculatorCategory>;
  createFinancialCalculator?: Maybe<FinancialCalculator>;
  createLandingPage?: Maybe<LandingPage>;
  createLender?: Maybe<Lender>;
  createLenderTier?: Maybe<LenderTier>;
  createLoanCalculator?: Maybe<LoanCalculator>;
  createMenu?: Maybe<Menu>;
  createPage?: Maybe<Page>;
  createPageCategory?: Maybe<PageCategory>;
  createResourceArticle?: Maybe<ResourceArticle>;
  createResourceCategory?: Maybe<ResourceCategory>;
  createReview?: Maybe<Review>;
  createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  createSyncLog?: Maybe<SyncLog>;
  createTeamMember?: Maybe<TeamMember>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteAbout?: Maybe<DeleteMutationResponse>;
  deleteCalculatorCategory?: Maybe<DeleteMutationResponse>;
  deleteContact?: Maybe<DeleteMutationResponse>;
  deleteFinancialCalculator?: Maybe<DeleteMutationResponse>;
  deleteHomepage?: Maybe<DeleteMutationResponse>;
  deleteLandingPage?: Maybe<DeleteMutationResponse>;
  deleteLender?: Maybe<DeleteMutationResponse>;
  deleteLenderTier?: Maybe<DeleteMutationResponse>;
  deleteLoanCalculator?: Maybe<DeleteMutationResponse>;
  deleteMenu?: Maybe<DeleteMutationResponse>;
  deletePage?: Maybe<DeleteMutationResponse>;
  deletePageCategory?: Maybe<DeleteMutationResponse>;
  deleteResourceArticle?: Maybe<DeleteMutationResponse>;
  deleteResourceCategory?: Maybe<DeleteMutationResponse>;
  deleteResourceCenter?: Maybe<DeleteMutationResponse>;
  deleteReview?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
  deleteSiteSetting?: Maybe<DeleteMutationResponse>;
  deleteSyncLog?: Maybe<DeleteMutationResponse>;
  deleteTeamMember?: Maybe<DeleteMutationResponse>;
  deleteUploadFile?: Maybe<UploadFile>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateAbout?: Maybe<About>;
  updateCalculatorCategory?: Maybe<CalculatorCategory>;
  updateContact?: Maybe<Contact>;
  updateFinancialCalculator?: Maybe<FinancialCalculator>;
  updateHomepage?: Maybe<Homepage>;
  updateLandingPage?: Maybe<LandingPage>;
  updateLender?: Maybe<Lender>;
  updateLenderTier?: Maybe<LenderTier>;
  updateLoanCalculator?: Maybe<LoanCalculator>;
  updateMenu?: Maybe<Menu>;
  updatePage?: Maybe<Page>;
  updatePageCategory?: Maybe<PageCategory>;
  updateResourceArticle?: Maybe<ResourceArticle>;
  updateResourceCategory?: Maybe<ResourceCategory>;
  updateResourceCenter?: Maybe<ResourceCenter>;
  updateReview?: Maybe<Review>;
  updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updateSiteSetting?: Maybe<SiteSetting>;
  updateSyncLog?: Maybe<SyncLog>;
  updateTeamMember?: Maybe<TeamMember>;
  updateUploadFile: UploadFile;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
};

export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

export type MutationCreateCalculatorCategoryArgs = {
  data: CalculatorCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateFinancialCalculatorArgs = {
  data: FinancialCalculatorInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateLandingPageArgs = {
  data: LandingPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateLenderArgs = {
  data: LenderInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateLenderTierArgs = {
  data: LenderTierInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateLoanCalculatorArgs = {
  data: LoanCalculatorInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateMenuArgs = {
  data: MenuInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePageArgs = {
  data: PageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePageCategoryArgs = {
  data: PageCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateResourceArticleArgs = {
  data: ResourceArticleInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateResourceCategoryArgs = {
  data: ResourceCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateReviewArgs = {
  data: ReviewInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSyncLogArgs = {
  data: SyncLogInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateTeamMemberArgs = {
  data: TeamMemberInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};

export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};

export type MutationDeleteCalculatorCategoryArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteFinancialCalculatorArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteLandingPageArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteLenderArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteLenderTierArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteLoanCalculatorArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteMenuArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeletePageArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeletePageCategoryArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteResourceArticleArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteResourceCategoryArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteReviewArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteSyncLogArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteTeamMemberArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};

export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};

export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};

export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};

export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

export type MutationUpdateAboutArgs = {
  data: AboutInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCalculatorCategoryArgs = {
  data: CalculatorCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateContactArgs = {
  data: ContactInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateFinancialCalculatorArgs = {
  data: FinancialCalculatorInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateHomepageArgs = {
  data: HomepageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLandingPageArgs = {
  data: LandingPageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLenderArgs = {
  data: LenderInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLenderTierArgs = {
  data: LenderTierInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLoanCalculatorArgs = {
  data: LoanCalculatorInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateMenuArgs = {
  data: MenuInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePageArgs = {
  data: PageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePageCategoryArgs = {
  data: PageCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateResourceArticleArgs = {
  data: ResourceArticleInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateResourceCategoryArgs = {
  data: ResourceCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateResourceCenterArgs = {
  data: ResourceCenterInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateReviewArgs = {
  data: ReviewInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSiteSettingArgs = {
  data: SiteSettingInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSyncLogArgs = {
  data: SyncLogInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateTeamMemberArgs = {
  data: TeamMemberInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};

export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};

export type Page = {
  __typename?: 'Page';
  Blocks?: Maybe<Array<Maybe<PageBlocksDynamicZone>>>;
  FunnelPopupTimer?: Maybe<Scalars['Int']['output']>;
  IncludeAllBlocksInJumplinks?: Maybe<Scalars['Boolean']['output']>;
  NoIndex?: Maybe<Scalars['Boolean']['output']>;
  PageCategory?: Maybe<PageCategory>;
  PageHero?: Maybe<ComponentBlocksHeroForm>;
  PageHeroSimple?: Maybe<ComponentBlocksHeroSimple>;
  PageSidebar?: Maybe<ComponentSharedSideBarContent>;
  PopupFunnel?: Maybe<Scalars['Boolean']['output']>;
  ShowReviews?: Maybe<Scalars['Boolean']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PageBlocksDynamicZone =
  | ComponentBlocksActionBlock
  | ComponentBlocksAdditionalFeatures
  | ComponentBlocksAuthorDetails
  | ComponentBlocksBreak
  | ComponentBlocksCalculatorGrid
  | ComponentBlocksCta
  | ComponentBlocksFaqList
  | ComponentBlocksFunnel
  | ComponentBlocksHighlightBlock
  | ComponentBlocksHtml
  | ComponentBlocksImage
  | ComponentBlocksInfoTilesBlock
  | ComponentBlocksLatestResourcesBlock
  | ComponentBlocksLenderList
  | ComponentBlocksLoanCalculators
  | ComponentBlocksMetricHighlight
  | ComponentBlocksPageSeparator
  | ComponentBlocksPlatformReviewsBlock
  | ComponentBlocksPostcard
  | ComponentBlocksProductFeatures
  | ComponentBlocksProsAndConsTable
  | ComponentBlocksProsAndConsTableV2
  | ComponentBlocksRelatedArticles
  | ComponentBlocksRelatedBlogs
  | ComponentBlocksStepsList
  | ComponentBlocksTableWidget
  | ComponentBlocksText
  | ComponentBlocksThreeColumnText
  | ComponentBlocksThreeSteps
  | ComponentBlocksTwoColumnTextImageBlock
  | ComponentCalculatorCalculatorHighlight
  | ComponentLoanLoanComparison
  | ComponentLoanLoanHighlight
  | Error;

export type PageCategory = {
  __typename?: 'PageCategory';
  CategoryName: Scalars['String']['output'];
  ChildCategories: Array<Maybe<PageCategory>>;
  ChildCategories_connection?: Maybe<PageCategoryRelationResponseCollection>;
  ChildPagesShowLendIqLoginInHeader?: Maybe<Scalars['Boolean']['output']>;
  LandingPage?: Maybe<LandingPage>;
  Pages: Array<Maybe<Page>>;
  Pages_connection?: Maybe<PageRelationResponseCollection>;
  ParentCategory?: Maybe<PageCategory>;
  Slug: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PageCategoryChildCategoriesArgs = {
  filters?: InputMaybe<PageCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageCategoryChildCategories_ConnectionArgs = {
  filters?: InputMaybe<PageCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageCategoryPagesArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageCategoryPages_ConnectionArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageCategoryEntityResponseCollection = {
  __typename?: 'PageCategoryEntityResponseCollection';
  nodes: Array<PageCategory>;
  pageInfo: Pagination;
};

export type PageCategoryFiltersInput = {
  CategoryName?: InputMaybe<StringFilterInput>;
  ChildCategories?: InputMaybe<PageCategoryFiltersInput>;
  ChildPagesShowLendIqLoginInHeader?: InputMaybe<BooleanFilterInput>;
  LandingPage?: InputMaybe<LandingPageFiltersInput>;
  Pages?: InputMaybe<PageFiltersInput>;
  ParentCategory?: InputMaybe<PageCategoryFiltersInput>;
  Slug?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<PageCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PageCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PageCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PageCategoryInput = {
  CategoryName?: InputMaybe<Scalars['String']['input']>;
  ChildCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ChildPagesShowLendIqLoginInHeader?: InputMaybe<Scalars['Boolean']['input']>;
  LandingPage?: InputMaybe<Scalars['ID']['input']>;
  Pages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ParentCategory?: InputMaybe<Scalars['ID']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageCategoryRelationResponseCollection = {
  __typename?: 'PageCategoryRelationResponseCollection';
  nodes: Array<PageCategory>;
};

export type PageEntityResponseCollection = {
  __typename?: 'PageEntityResponseCollection';
  nodes: Array<Page>;
  pageInfo: Pagination;
};

export type PageFiltersInput = {
  FunnelPopupTimer?: InputMaybe<IntFilterInput>;
  IncludeAllBlocksInJumplinks?: InputMaybe<BooleanFilterInput>;
  NoIndex?: InputMaybe<BooleanFilterInput>;
  PageCategory?: InputMaybe<PageCategoryFiltersInput>;
  PageHero?: InputMaybe<ComponentBlocksHeroFormFiltersInput>;
  PageHeroSimple?: InputMaybe<ComponentBlocksHeroSimpleFiltersInput>;
  PageSidebar?: InputMaybe<ComponentSharedSideBarContentFiltersInput>;
  PopupFunnel?: InputMaybe<BooleanFilterInput>;
  ShowReviews?: InputMaybe<BooleanFilterInput>;
  Slug?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PageInput = {
  Blocks?: InputMaybe<Array<Scalars['PageBlocksDynamicZoneInput']['input']>>;
  FunnelPopupTimer?: InputMaybe<Scalars['Int']['input']>;
  IncludeAllBlocksInJumplinks?: InputMaybe<Scalars['Boolean']['input']>;
  NoIndex?: InputMaybe<Scalars['Boolean']['input']>;
  PageCategory?: InputMaybe<Scalars['ID']['input']>;
  PageHero?: InputMaybe<ComponentBlocksHeroFormInput>;
  PageHeroSimple?: InputMaybe<ComponentBlocksHeroSimpleInput>;
  PageSidebar?: InputMaybe<ComponentSharedSideBarContentInput>;
  PopupFunnel?: InputMaybe<Scalars['Boolean']['input']>;
  ShowReviews?: InputMaybe<Scalars['Boolean']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
};

export type PageRelationResponseCollection = {
  __typename?: 'PageRelationResponseCollection';
  nodes: Array<Page>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export enum PublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export type Query = {
  __typename?: 'Query';
  about?: Maybe<About>;
  calculatorCategories: Array<Maybe<CalculatorCategory>>;
  calculatorCategories_connection?: Maybe<CalculatorCategoryEntityResponseCollection>;
  calculatorCategory?: Maybe<CalculatorCategory>;
  contact?: Maybe<Contact>;
  financialCalculator?: Maybe<FinancialCalculator>;
  financialCalculators: Array<Maybe<FinancialCalculator>>;
  financialCalculators_connection?: Maybe<FinancialCalculatorEntityResponseCollection>;
  homepage?: Maybe<Homepage>;
  i18NLocale?: Maybe<I18NLocale>;
  i18NLocales: Array<Maybe<I18NLocale>>;
  i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
  landingPage?: Maybe<LandingPage>;
  landingPages: Array<Maybe<LandingPage>>;
  landingPages_connection?: Maybe<LandingPageEntityResponseCollection>;
  lender?: Maybe<Lender>;
  lenderTier?: Maybe<LenderTier>;
  lenderTiers: Array<Maybe<LenderTier>>;
  lenderTiers_connection?: Maybe<LenderTierEntityResponseCollection>;
  lenders: Array<Maybe<Lender>>;
  lenders_connection?: Maybe<LenderEntityResponseCollection>;
  loanCalculator?: Maybe<LoanCalculator>;
  loanCalculators: Array<Maybe<LoanCalculator>>;
  loanCalculators_connection?: Maybe<LoanCalculatorEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  menu?: Maybe<Menu>;
  menus: Array<Maybe<Menu>>;
  menus_connection?: Maybe<MenuEntityResponseCollection>;
  page?: Maybe<Page>;
  pageCategories: Array<Maybe<PageCategory>>;
  pageCategories_connection?: Maybe<PageCategoryEntityResponseCollection>;
  pageCategory?: Maybe<PageCategory>;
  pages: Array<Maybe<Page>>;
  pages_connection?: Maybe<PageEntityResponseCollection>;
  resourceArticle?: Maybe<ResourceArticle>;
  resourceArticles: Array<Maybe<ResourceArticle>>;
  resourceArticles_connection?: Maybe<ResourceArticleEntityResponseCollection>;
  resourceCategories: Array<Maybe<ResourceCategory>>;
  resourceCategories_connection?: Maybe<ResourceCategoryEntityResponseCollection>;
  resourceCategory?: Maybe<ResourceCategory>;
  resourceCenter?: Maybe<ResourceCenter>;
  review?: Maybe<Review>;
  reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
  reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
  reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
  reviews: Array<Maybe<Review>>;
  reviews_connection?: Maybe<ReviewEntityResponseCollection>;
  siteSetting?: Maybe<SiteSetting>;
  syncLog?: Maybe<SyncLog>;
  syncLogs: Array<Maybe<SyncLog>>;
  syncLogs_connection?: Maybe<SyncLogEntityResponseCollection>;
  teamMember?: Maybe<TeamMember>;
  teamMembers: Array<Maybe<TeamMember>>;
  teamMembers_connection?: Maybe<TeamMemberEntityResponseCollection>;
  uploadFile?: Maybe<UploadFile>;
  uploadFiles: Array<Maybe<UploadFile>>;
  uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRole>;
  usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
  usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUser>;
  usersPermissionsUsers: Array<Maybe<UsersPermissionsUser>>;
  usersPermissionsUsers_connection?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};

export type QueryAboutArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCalculatorCategoriesArgs = {
  filters?: InputMaybe<CalculatorCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCalculatorCategories_ConnectionArgs = {
  filters?: InputMaybe<CalculatorCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCalculatorCategoryArgs = {
  documentId: Scalars['ID']['input'];
};

export type QueryContactArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryFinancialCalculatorArgs = {
  documentId: Scalars['ID']['input'];
};

export type QueryFinancialCalculatorsArgs = {
  filters?: InputMaybe<FinancialCalculatorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryFinancialCalculators_ConnectionArgs = {
  filters?: InputMaybe<FinancialCalculatorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryHomepageArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryI18NLocaleArgs = {
  documentId: Scalars['ID']['input'];
};

export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryI18NLocales_ConnectionArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryLandingPageArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLandingPagesArgs = {
  filters?: InputMaybe<LandingPageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLandingPages_ConnectionArgs = {
  filters?: InputMaybe<LandingPageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLenderArgs = {
  documentId: Scalars['ID']['input'];
};

export type QueryLenderTierArgs = {
  documentId: Scalars['ID']['input'];
};

export type QueryLenderTiersArgs = {
  filters?: InputMaybe<LenderTierFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryLenderTiers_ConnectionArgs = {
  filters?: InputMaybe<LenderTierFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryLendersArgs = {
  filters?: InputMaybe<LenderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryLenders_ConnectionArgs = {
  filters?: InputMaybe<LenderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryLoanCalculatorArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLoanCalculatorsArgs = {
  filters?: InputMaybe<LoanCalculatorFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLoanCalculators_ConnectionArgs = {
  filters?: InputMaybe<LoanCalculatorFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryMenuArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryMenusArgs = {
  filters?: InputMaybe<MenuFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryMenus_ConnectionArgs = {
  filters?: InputMaybe<MenuFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPageArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPageCategoriesArgs = {
  filters?: InputMaybe<PageCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPageCategories_ConnectionArgs = {
  filters?: InputMaybe<PageCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPageCategoryArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPagesArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPages_ConnectionArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceArticleArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceArticlesArgs = {
  filters?: InputMaybe<ResourceArticleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceArticles_ConnectionArgs = {
  filters?: InputMaybe<ResourceArticleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceCategoriesArgs = {
  filters?: InputMaybe<ResourceCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceCategories_ConnectionArgs = {
  filters?: InputMaybe<ResourceCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceCategoryArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceCenterArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
};

export type QueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
};

export type QueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryReviewWorkflowsWorkflowsArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryReviewsArgs = {
  filters?: InputMaybe<ReviewFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviews_ConnectionArgs = {
  filters?: InputMaybe<ReviewFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySiteSettingArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySyncLogArgs = {
  documentId: Scalars['ID']['input'];
};

export type QuerySyncLogsArgs = {
  filters?: InputMaybe<SyncLogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySyncLogs_ConnectionArgs = {
  filters?: InputMaybe<SyncLogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTeamMemberArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryTeamMembersArgs = {
  filters?: InputMaybe<TeamMemberFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryTeamMembers_ConnectionArgs = {
  filters?: InputMaybe<TeamMemberFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUploadFileArgs = {
  documentId: Scalars['ID']['input'];
};

export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUploadFiles_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUsersPermissionsRoleArgs = {
  documentId: Scalars['ID']['input'];
};

export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUsersPermissionsUserArgs = {
  documentId: Scalars['ID']['input'];
};

export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUsersPermissionsUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResourceArticle = {
  __typename?: 'ResourceArticle';
  ArticleExplainer?: Maybe<ComponentSharedArticleExplainer>;
  Author?: Maybe<TeamMember>;
  Blocks?: Maybe<Array<Maybe<ResourceArticleBlocksDynamicZone>>>;
  FunnelPopupTimer?: Maybe<Scalars['Int']['output']>;
  HeroImage?: Maybe<UploadFile>;
  IncludeInLatestBlock: Scalars['Boolean']['output'];
  NoIndex?: Maybe<Scalars['Boolean']['output']>;
  OverridePublishDate?: Maybe<Scalars['DateTime']['output']>;
  PopupFunnel?: Maybe<Scalars['Boolean']['output']>;
  ResourceCategory?: Maybe<ResourceCategory>;
  ResourceDescription?: Maybe<Scalars['String']['output']>;
  ResourceIntro?: Maybe<Scalars['JSON']['output']>;
  ResourceThumbnail?: Maybe<UploadFile>;
  ResourceTitle: Scalars['String']['output'];
  ShowDatePublished?: Maybe<Scalars['Boolean']['output']>;
  ShowLastUpdated?: Maybe<Scalars['Boolean']['output']>;
  Sidebar?: Maybe<ComponentSharedSideBarContent>;
  Slug: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ResourceArticleBlocksDynamicZone =
  | ComponentBlocksActionBlock
  | ComponentBlocksAdditionalFeatures
  | ComponentBlocksAuthorDetails
  | ComponentBlocksBreak
  | ComponentBlocksCalculatorGrid
  | ComponentBlocksCta
  | ComponentBlocksFaqList
  | ComponentBlocksFunnel
  | ComponentBlocksHighlightBlock
  | ComponentBlocksHtml
  | ComponentBlocksImage
  | ComponentBlocksInfoTilesBlock
  | ComponentBlocksLatestResourcesBlock
  | ComponentBlocksLenderList
  | ComponentBlocksLoanCalculators
  | ComponentBlocksMetricHighlight
  | ComponentBlocksPageSeparator
  | ComponentBlocksPlatformReviewsBlock
  | ComponentBlocksPostcard
  | ComponentBlocksProductFeatures
  | ComponentBlocksProsAndConsTable
  | ComponentBlocksProsAndConsTableV2
  | ComponentBlocksRelatedArticles
  | ComponentBlocksRelatedBlogs
  | ComponentBlocksStepsList
  | ComponentBlocksTableWidget
  | ComponentBlocksText
  | ComponentBlocksThreeColumnText
  | ComponentBlocksThreeSteps
  | ComponentBlocksTwoColumnTextImageBlock
  | ComponentCalculatorCalculatorHighlight
  | ComponentLoanLoanComparison
  | ComponentLoanLoanHighlight
  | Error;

export type ResourceArticleEntityResponseCollection = {
  __typename?: 'ResourceArticleEntityResponseCollection';
  nodes: Array<ResourceArticle>;
  pageInfo: Pagination;
};

export type ResourceArticleFiltersInput = {
  ArticleExplainer?: InputMaybe<ComponentSharedArticleExplainerFiltersInput>;
  Author?: InputMaybe<TeamMemberFiltersInput>;
  FunnelPopupTimer?: InputMaybe<IntFilterInput>;
  IncludeInLatestBlock?: InputMaybe<BooleanFilterInput>;
  NoIndex?: InputMaybe<BooleanFilterInput>;
  OverridePublishDate?: InputMaybe<DateTimeFilterInput>;
  PopupFunnel?: InputMaybe<BooleanFilterInput>;
  ResourceCategory?: InputMaybe<ResourceCategoryFiltersInput>;
  ResourceDescription?: InputMaybe<StringFilterInput>;
  ResourceIntro?: InputMaybe<JsonFilterInput>;
  ResourceTitle?: InputMaybe<StringFilterInput>;
  ShowDatePublished?: InputMaybe<BooleanFilterInput>;
  ShowLastUpdated?: InputMaybe<BooleanFilterInput>;
  Sidebar?: InputMaybe<ComponentSharedSideBarContentFiltersInput>;
  Slug?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ResourceArticleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ResourceArticleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ResourceArticleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ResourceArticleInput = {
  ArticleExplainer?: InputMaybe<ComponentSharedArticleExplainerInput>;
  Author?: InputMaybe<Scalars['ID']['input']>;
  Blocks?: InputMaybe<Array<Scalars['ResourceArticleBlocksDynamicZoneInput']['input']>>;
  FunnelPopupTimer?: InputMaybe<Scalars['Int']['input']>;
  HeroImage?: InputMaybe<Scalars['ID']['input']>;
  IncludeInLatestBlock?: InputMaybe<Scalars['Boolean']['input']>;
  NoIndex?: InputMaybe<Scalars['Boolean']['input']>;
  OverridePublishDate?: InputMaybe<Scalars['DateTime']['input']>;
  PopupFunnel?: InputMaybe<Scalars['Boolean']['input']>;
  ResourceCategory?: InputMaybe<Scalars['ID']['input']>;
  ResourceDescription?: InputMaybe<Scalars['String']['input']>;
  ResourceIntro?: InputMaybe<Scalars['JSON']['input']>;
  ResourceThumbnail?: InputMaybe<Scalars['ID']['input']>;
  ResourceTitle?: InputMaybe<Scalars['String']['input']>;
  ShowDatePublished?: InputMaybe<Scalars['Boolean']['input']>;
  ShowLastUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  Sidebar?: InputMaybe<ComponentSharedSideBarContentInput>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
};

export type ResourceArticleRelationResponseCollection = {
  __typename?: 'ResourceArticleRelationResponseCollection';
  nodes: Array<ResourceArticle>;
};

export type ResourceCategory = {
  __typename?: 'ResourceCategory';
  Blocks?: Maybe<Array<Maybe<ResourceCategoryBlocksDynamicZone>>>;
  CategoryHero: UploadFile;
  CategoryIntro: Scalars['JSON']['output'];
  CategoryName: Scalars['String']['output'];
  Order?: Maybe<Scalars['Int']['output']>;
  ResourceArticles: Array<Maybe<ResourceArticle>>;
  ResourceArticles_connection?: Maybe<ResourceArticleRelationResponseCollection>;
  Slug: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ResourceCategoryResourceArticlesArgs = {
  filters?: InputMaybe<ResourceArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResourceCategoryResourceArticles_ConnectionArgs = {
  filters?: InputMaybe<ResourceArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResourceCategoryBlocksDynamicZone =
  | ComponentBlocksActionBlock
  | ComponentBlocksAdditionalFeatures
  | ComponentBlocksAuthorDetails
  | ComponentBlocksBreak
  | ComponentBlocksCalculatorGrid
  | ComponentBlocksCta
  | ComponentBlocksFaqList
  | ComponentBlocksFunnel
  | ComponentBlocksHighlightBlock
  | ComponentBlocksHtml
  | ComponentBlocksImage
  | ComponentBlocksInfoTilesBlock
  | ComponentBlocksLatestResourcesBlock
  | ComponentBlocksLenderList
  | ComponentBlocksLoanCalculators
  | ComponentBlocksMetricHighlight
  | ComponentBlocksPageSeparator
  | ComponentBlocksPlatformReviewsBlock
  | ComponentBlocksPostcard
  | ComponentBlocksProductFeatures
  | ComponentBlocksProsAndConsTable
  | ComponentBlocksProsAndConsTableV2
  | ComponentBlocksRelatedArticles
  | ComponentBlocksRelatedBlogs
  | ComponentBlocksStepsList
  | ComponentBlocksTableWidget
  | ComponentBlocksText
  | ComponentBlocksThreeColumnText
  | ComponentBlocksThreeSteps
  | ComponentBlocksTwoColumnTextImageBlock
  | ComponentCalculatorCalculatorHighlight
  | ComponentLoanLoanComparison
  | ComponentLoanLoanHighlight
  | Error;

export type ResourceCategoryEntityResponseCollection = {
  __typename?: 'ResourceCategoryEntityResponseCollection';
  nodes: Array<ResourceCategory>;
  pageInfo: Pagination;
};

export type ResourceCategoryFiltersInput = {
  CategoryIntro?: InputMaybe<JsonFilterInput>;
  CategoryName?: InputMaybe<StringFilterInput>;
  Order?: InputMaybe<IntFilterInput>;
  ResourceArticles?: InputMaybe<ResourceArticleFiltersInput>;
  Slug?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ResourceCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ResourceCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ResourceCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ResourceCategoryInput = {
  Blocks?: InputMaybe<Array<Scalars['ResourceCategoryBlocksDynamicZoneInput']['input']>>;
  CategoryHero?: InputMaybe<Scalars['ID']['input']>;
  CategoryIntro?: InputMaybe<Scalars['JSON']['input']>;
  CategoryName?: InputMaybe<Scalars['String']['input']>;
  Order?: InputMaybe<Scalars['Int']['input']>;
  ResourceArticles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ResourceCategoryRelationResponseCollection = {
  __typename?: 'ResourceCategoryRelationResponseCollection';
  nodes: Array<ResourceCategory>;
};

export type ResourceCenter = {
  __typename?: 'ResourceCenter';
  BlocksAboveCategories?: Maybe<Array<Maybe<ResourceCenterBlocksAboveCategoriesDynamicZone>>>;
  BlocksBelowCategories?: Maybe<Array<Maybe<ResourceCenterBlocksBelowCategoriesDynamicZone>>>;
  Intro?: Maybe<Scalars['JSON']['output']>;
  Title: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ResourceCenterBlocksAboveCategoriesDynamicZone =
  | ComponentBlocksActionBlock
  | ComponentBlocksAdditionalFeatures
  | ComponentBlocksAuthorDetails
  | ComponentBlocksBreak
  | ComponentBlocksCalculatorGrid
  | ComponentBlocksCta
  | ComponentBlocksFaqList
  | ComponentBlocksFunnel
  | ComponentBlocksHighlightBlock
  | ComponentBlocksHtml
  | ComponentBlocksImage
  | ComponentBlocksInfoTilesBlock
  | ComponentBlocksLatestResourcesBlock
  | ComponentBlocksLenderList
  | ComponentBlocksLoanCalculators
  | ComponentBlocksMetricHighlight
  | ComponentBlocksPageSeparator
  | ComponentBlocksPlatformReviewsBlock
  | ComponentBlocksPostcard
  | ComponentBlocksProductFeatures
  | ComponentBlocksProsAndConsTable
  | ComponentBlocksProsAndConsTableV2
  | ComponentBlocksRelatedArticles
  | ComponentBlocksRelatedBlogs
  | ComponentBlocksStepsList
  | ComponentBlocksTableWidget
  | ComponentBlocksText
  | ComponentBlocksThreeColumnText
  | ComponentBlocksThreeSteps
  | ComponentBlocksTwoColumnTextImageBlock
  | ComponentCalculatorCalculatorHighlight
  | ComponentLoanLoanComparison
  | ComponentLoanLoanHighlight
  | Error;

export type ResourceCenterBlocksBelowCategoriesDynamicZone =
  | ComponentBlocksActionBlock
  | ComponentBlocksAdditionalFeatures
  | ComponentBlocksAuthorDetails
  | ComponentBlocksBreak
  | ComponentBlocksCalculatorGrid
  | ComponentBlocksCta
  | ComponentBlocksFaqList
  | ComponentBlocksFunnel
  | ComponentBlocksHighlightBlock
  | ComponentBlocksHtml
  | ComponentBlocksImage
  | ComponentBlocksInfoTilesBlock
  | ComponentBlocksLatestResourcesBlock
  | ComponentBlocksLenderList
  | ComponentBlocksLoanCalculators
  | ComponentBlocksMetricHighlight
  | ComponentBlocksPageSeparator
  | ComponentBlocksPlatformReviewsBlock
  | ComponentBlocksPostcard
  | ComponentBlocksProductFeatures
  | ComponentBlocksProsAndConsTable
  | ComponentBlocksProsAndConsTableV2
  | ComponentBlocksRelatedArticles
  | ComponentBlocksRelatedBlogs
  | ComponentBlocksStepsList
  | ComponentBlocksTableWidget
  | ComponentBlocksText
  | ComponentBlocksThreeColumnText
  | ComponentBlocksThreeSteps
  | ComponentBlocksTwoColumnTextImageBlock
  | ComponentCalculatorCalculatorHighlight
  | ComponentLoanLoanComparison
  | ComponentLoanLoanHighlight
  | Error;

export type ResourceCenterInput = {
  BlocksAboveCategories?: InputMaybe<
    Array<Scalars['ResourceCenterBlocksAboveCategoriesDynamicZoneInput']['input']>
  >;
  BlocksBelowCategories?: InputMaybe<
    Array<Scalars['ResourceCenterBlocksBelowCategoriesDynamicZoneInput']['input']>
  >;
  Intro?: InputMaybe<Scalars['JSON']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Review = {
  __typename?: 'Review';
  Active?: Maybe<Scalars['Boolean']['output']>;
  Author: Scalars['String']['output'];
  Avatar?: Maybe<UploadFile>;
  CompanyName?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  ReviewDate?: Maybe<Scalars['Date']['output']>;
  ReviewText: Scalars['String']['output'];
  ReviewType: Enum_Review_Reviewtype;
  Role?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReviewEntityResponseCollection = {
  __typename?: 'ReviewEntityResponseCollection';
  nodes: Array<Review>;
  pageInfo: Pagination;
};

export type ReviewFiltersInput = {
  Active?: InputMaybe<BooleanFilterInput>;
  Author?: InputMaybe<StringFilterInput>;
  CompanyName?: InputMaybe<StringFilterInput>;
  Rating?: InputMaybe<IntFilterInput>;
  ReviewText?: InputMaybe<StringFilterInput>;
  ReviewType?: InputMaybe<StringFilterInput>;
  Role?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ReviewFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ReviewFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReviewInput = {
  Active?: InputMaybe<Scalars['Boolean']['input']>;
  Author?: InputMaybe<Scalars['String']['input']>;
  Avatar?: InputMaybe<Scalars['ID']['input']>;
  CompanyName?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  ReviewText?: InputMaybe<Scalars['String']['input']>;
  ReviewType?: InputMaybe<Enum_Review_Reviewtype>;
  Role?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ReviewWorkflowsWorkflow = {
  __typename?: 'ReviewWorkflowsWorkflow';
  contentTypes: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
  stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflow>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  contentTypes?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  stageRequiredToPublish?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  stages?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReviewWorkflowsWorkflowInput = {
  contentTypes?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stageRequiredToPublish?: InputMaybe<Scalars['ID']['input']>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ReviewWorkflowsWorkflowStage = {
  __typename?: 'ReviewWorkflowsWorkflowStage';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workflow?: Maybe<ReviewWorkflowsWorkflow>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workflow?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workflow?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageRelationResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type SiteSetting = {
  __typename?: 'SiteSetting';
  Awards?: Maybe<Array<Maybe<ComponentSharedAward>>>;
  AwardsHeading?: Maybe<Scalars['String']['output']>;
  CertificationLogos?: Maybe<Array<Maybe<ComponentSharedFooterLogo>>>;
  CertificationLogosHeading?: Maybe<Scalars['String']['output']>;
  CertificationLogosText?: Maybe<Scalars['String']['output']>;
  CertificationLogosTopSpacing?: Maybe<Scalars['Int']['output']>;
  ContactUsFormHeader?: Maybe<Scalars['JSON']['output']>;
  ContactUsNumber?: Maybe<Scalars['String']['output']>;
  ContactUsPrompt?: Maybe<Scalars['String']['output']>;
  GetStartedUrl?: Maybe<Scalars['String']['output']>;
  HomepageCtaActionUrl?: Maybe<Scalars['String']['output']>;
  HomepageCtaDefaultAmount?: Maybe<Scalars['String']['output']>;
  LenderLogos: Array<Maybe<UploadFile>>;
  LenderLogos_connection?: Maybe<UploadFileRelationResponseCollection>;
  MetadataDefaultOgImage?: Maybe<UploadFile>;
  MetadataOrgAddressCountry?: Maybe<Scalars['String']['output']>;
  MetadataOrgAddressLocality?: Maybe<Scalars['String']['output']>;
  MetadataOrgAddressRegion?: Maybe<Scalars['String']['output']>;
  MetadataOrgDescription?: Maybe<Scalars['String']['output']>;
  MetadataOrgEmail?: Maybe<Scalars['String']['output']>;
  MetadataOrgFoundingDate?: Maybe<Scalars['String']['output']>;
  MetadataOrgLegalName?: Maybe<Scalars['String']['output']>;
  MetadataOrgPostalCode?: Maybe<Scalars['String']['output']>;
  MetadataOrgStreetAddress?: Maybe<Scalars['String']['output']>;
  SignInUrl?: Maybe<Scalars['String']['output']>;
  Socials?: Maybe<Array<Maybe<ComponentSharedSocialLink>>>;
  SocialsHeading?: Maybe<Scalars['String']['output']>;
  TermsText?: Maybe<Scalars['JSON']['output']>;
  TrustBadge?: Maybe<Scalars['String']['output']>;
  TrustHeading?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Array<Maybe<ComponentSharedSiteBanner>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SiteSettingAwardsArgs = {
  filters?: InputMaybe<ComponentSharedAwardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteSettingCertificationLogosArgs = {
  filters?: InputMaybe<ComponentSharedFooterLogoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteSettingLenderLogosArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteSettingLenderLogos_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteSettingSocialsArgs = {
  filters?: InputMaybe<ComponentSharedSocialLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteSettingBannerArgs = {
  filters?: InputMaybe<ComponentSharedSiteBannerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteSettingInput = {
  Awards?: InputMaybe<Array<InputMaybe<ComponentSharedAwardInput>>>;
  AwardsHeading?: InputMaybe<Scalars['String']['input']>;
  CertificationLogos?: InputMaybe<Array<InputMaybe<ComponentSharedFooterLogoInput>>>;
  CertificationLogosHeading?: InputMaybe<Scalars['String']['input']>;
  CertificationLogosText?: InputMaybe<Scalars['String']['input']>;
  CertificationLogosTopSpacing?: InputMaybe<Scalars['Int']['input']>;
  ContactUsFormHeader?: InputMaybe<Scalars['JSON']['input']>;
  ContactUsNumber?: InputMaybe<Scalars['String']['input']>;
  ContactUsPrompt?: InputMaybe<Scalars['String']['input']>;
  GetStartedUrl?: InputMaybe<Scalars['String']['input']>;
  HomepageCtaActionUrl?: InputMaybe<Scalars['String']['input']>;
  HomepageCtaDefaultAmount?: InputMaybe<Scalars['String']['input']>;
  LenderLogos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  MetadataDefaultOgImage?: InputMaybe<Scalars['ID']['input']>;
  MetadataOrgAddressCountry?: InputMaybe<Scalars['String']['input']>;
  MetadataOrgAddressLocality?: InputMaybe<Scalars['String']['input']>;
  MetadataOrgAddressRegion?: InputMaybe<Scalars['String']['input']>;
  MetadataOrgDescription?: InputMaybe<Scalars['String']['input']>;
  MetadataOrgEmail?: InputMaybe<Scalars['String']['input']>;
  MetadataOrgFoundingDate?: InputMaybe<Scalars['String']['input']>;
  MetadataOrgLegalName?: InputMaybe<Scalars['String']['input']>;
  MetadataOrgPostalCode?: InputMaybe<Scalars['String']['input']>;
  MetadataOrgStreetAddress?: InputMaybe<Scalars['String']['input']>;
  SignInUrl?: InputMaybe<Scalars['String']['input']>;
  Socials?: InputMaybe<Array<InputMaybe<ComponentSharedSocialLinkInput>>>;
  SocialsHeading?: InputMaybe<Scalars['String']['input']>;
  TermsText?: InputMaybe<Scalars['JSON']['input']>;
  TrustBadge?: InputMaybe<Scalars['String']['input']>;
  TrustHeading?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Array<InputMaybe<ComponentSharedSiteBannerInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SyncLog = {
  __typename?: 'SyncLog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  stats?: Maybe<Scalars['JSON']['output']>;
  syncStatus?: Maybe<Enum_Synclog_Syncstatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SyncLogEntityResponseCollection = {
  __typename?: 'SyncLogEntityResponseCollection';
  nodes: Array<SyncLog>;
  pageInfo: Pagination;
};

export type SyncLogFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SyncLogFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  finishedAt?: InputMaybe<DateTimeFilterInput>;
  message?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SyncLogFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SyncLogFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  startedAt?: InputMaybe<DateTimeFilterInput>;
  stats?: InputMaybe<JsonFilterInput>;
  syncStatus?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SyncLogInput = {
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stats?: InputMaybe<Scalars['JSON']['input']>;
  syncStatus?: InputMaybe<Enum_Synclog_Syncstatus>;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  Avatar?: Maybe<UploadFile>;
  Bio: Scalars['String']['output'];
  Email?: Maybe<Scalars['String']['output']>;
  FacebookUrl?: Maybe<Scalars['String']['output']>;
  InstagramUrl?: Maybe<Scalars['String']['output']>;
  LinkedInUrl?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ResourceArticles: Array<Maybe<ResourceArticle>>;
  ResourceArticles_connection?: Maybe<ResourceArticleRelationResponseCollection>;
  Role: Scalars['String']['output'];
  Title?: Maybe<Scalars['String']['output']>;
  XUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TeamMemberResourceArticlesArgs = {
  filters?: InputMaybe<ResourceArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TeamMemberResourceArticles_ConnectionArgs = {
  filters?: InputMaybe<ResourceArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TeamMemberEntityResponseCollection = {
  __typename?: 'TeamMemberEntityResponseCollection';
  nodes: Array<TeamMember>;
  pageInfo: Pagination;
};

export type TeamMemberFiltersInput = {
  Bio?: InputMaybe<StringFilterInput>;
  Email?: InputMaybe<StringFilterInput>;
  FacebookUrl?: InputMaybe<StringFilterInput>;
  InstagramUrl?: InputMaybe<StringFilterInput>;
  LinkedInUrl?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  ResourceArticles?: InputMaybe<ResourceArticleFiltersInput>;
  Role?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  XUrl?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TeamMemberFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<TeamMemberFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TeamMemberFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TeamMemberInput = {
  Avatar?: InputMaybe<Scalars['ID']['input']>;
  Bio?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  FacebookUrl?: InputMaybe<Scalars['String']['input']>;
  InstagramUrl?: InputMaybe<Scalars['String']['input']>;
  LinkedInUrl?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  ResourceArticles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Role?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  XUrl?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberRelationResponseCollection = {
  __typename?: 'TeamMemberRelationResponseCollection';
  nodes: Array<TeamMember>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  ext?: Maybe<Scalars['String']['output']>;
  focalPoint?: Maybe<Scalars['JSON']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  nodes: Array<UploadFile>;
  pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  focalPoint?: InputMaybe<JsonFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  nodes: Array<UploadFile>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Maybe<UsersPermissionsPermission>>;
  permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};

export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  nodes: Array<UsersPermissionsRole>;
  pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  nodes: Array<UsersPermissionsUser>;
  pageInfo: Pagination;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  provider?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  nodes: Array<UsersPermissionsUser>;
};
